<template>
    <div v-if="!loading" class="customer-order-wrapper">
        <div class="d-flex justify-content-between align-items-end customer-order-header" style="border-bottom: 1px solid black">
            <div class="row p-0 m-0" style="width: 100%">
							<div class="col">
								<span style="color: rgb(26, 42, 87); font-size: 32px; margin: 0;">
									Worksheet
								</span>
								<input class="worksheet-input" @change="saveWorksheetName()" placeholder="Worksheet Name" label="Worksheet Name" v-model="worksheetName" maxlength="50"/>
							</div>
							<div class="col">
								<span style="margin-top: 10px; float: right">
									<span style="margin-right: 25px">
										<favorite-indicator
											:orderId="$route.params.id"
											:key="favoritesKey"
										/>
									</span>

									<span v-if="this.orderNumber" class="header-order-id"><strong>Order#</strong>&nbsp;{{this.orderNumber}}</span>
									<span> </span>
									<span style="font-weight: bold; margin-left: 15px;">Order&nbsp;Status:&nbsp;</span>
									<span class="font-weight-bold" :class="orderStatus">{{orderStatus}}</span>
								</span>
							</div>
						</div>
        </div>

        <form @change="formChanged" class="customer-order">
            <div class="d-flex justify-content-between">
                <div class="row top-level-order-btns">
                        <div class="btn col btn-secondary ml-2 mr-2" @click="$router.back()" style="min-width: 60px">
                            <i class="fas fa-arrow-left text-primary mr-2"></i>Back
                        </div>
                        <div v-if="!isLimitedTransferUser && !isRestrictedSalesAdmin" class="btn col btn-secondary ml-2 mr-2" style="min-width: 120px" @click="newOrderHasBeenRequested">
                            <i class="fa fa-plus text-primary mr-2"></i>New Order
                        </div>
                        <div v-if="isRestrictedSalesAdmin && orderHasId" class="btn col btn-secondary ml-2 mr-2" style="min-width: 130px" @click="openTransferModal">
                            <i class="fa fa-exchange-alt text-primary mr-2"></i>Transfer Order
                        </div>
                        <div v-if="committed && !isReadOnly && dealer.OrderLinkEnabled && !isLimitedTransferUser"  style="min-width: 120px" @click="submitToOrderLink" class="btn col btn-secondary ml-2 mr-2 order-link-btn"><i class="fa fa-bolt mr-2"></i>OrderLink</div>
                        <div v-if="uncommitted && orderHasId && !isReadOnly && !isLimitedTransferUser" style="min-width: 120px" @click="toggleCommitModal" class="btn col btn-secondary ml-2 mr-2 text-success"><i class="fa fa-check mr-2"></i>Commit</div>

                        <!-- <div class="btn btn-secondary ml-2 mr-3">Generate Form</div> -->
                    <!-- </div>
                    <div class="col-6 row justify-content-flex-end"> -->
												<div v-if="orderHasId && !isLimitedTransferUser && !isReadOnly" class="btn btn-secondary" style="margin-left: 10px" @click="formBuilder">
														Generate Forms
														<span class="caret"></span>
												</div>

                        <div class="col justify-self-right ml-2 mr-2" :style="{minWidth: '140px'}">
                            <div v-if="!isLimitedTransferUser" class="dropdown">
                                <button class="btn btn-secondary dropdown-toggle" type="button" data-toggle="dropdown">Menu
                                <span class="caret"></span></button>
                                <ul class="dropdown-menu">
                                    <li class='pointer' v-if="uncommitted && !isReadOnly" @click="toggleImportAdecOrderModal">Import Quote</li>
                                    <li class='pointer' v-if="!isReadOnly" @click="saveOrderLocally">Save Order Locally</li>
                                    <li class='pointer' v-if="uncommitted && !isReadOnly" @click="toggleImportSmartSalesOrderModal">Load Saved Order</li>
                                    <li class='pointer' v-if="orderHasId && committed && currentUserSalesAdminOrMgr" @click="toggleUncommitModal">Uncommit Order</li>
                                    <li class='pointer' @click="cloneOrder">Duplicate Order</li>
                                    <li class='pointer' v-if="uncommitted && orderHasId && !isReadOnly" @click="toggleDeleteModal">Delete Order</li>
                                </ul>
                            </div>
                        </div>

                        <div class="first-line">
                            <div class="date-display__wrapper">
                                <div class="date-display__title"><strong>Created:</strong> {{ creationDate + ' ' + creationTime }}</div>
                            </div>
                            <div class="date-display__wrapper">
                                <div class="date-display__title"><strong>Last Revised:</strong> {{ revisionDate + ' ' + revisionTime }}</div>
                            </div>
                        </div>

												<div>&nbsp;</div>

                        <div class="second-line">
                            <div class="date-display__wrapper">
                                <div class="date-display__title"><strong>Committed:</strong> {{ orderStatusId > 1 ? committedDate + ' ' + committedTime : 'Not committed yet'}}</div>
                            </div>
                            <div class="date-display__wrapper">
                                <div class="date-display__title"><strong>Submitted:</strong> {{ orderStatusId > 2 ? submittedDate + ' ' + submittedTime : 'Not submitted yet'}}</div>
                            </div>
												</div>
                </div>
            </div>

            <hr>

            <!-- Read-Only Indicator -->
            <div v-if="isReadOnly" class="alert alert-info mb-3" role="alert">
                <i class="fas fa-lock mr-2"></i>
                <strong>READ-ONLY:</strong>
                <span v-if="isHistoricalView">
                    You are viewing a historical version of this order from {{ formatHistoricalTime }}.
                    <router-link v-if="orderVersioningEnabled && currentUserSalesAdminOrAbove" :to="{ name: 'OrderVersions', params: { id: $route.params.id } }" class="version-history-link">
                        Click Here to Return to Version History
                    </router-link>
                </span>
                <span v-else>
                    This order is in read-only mode. You can view the details but cannot make changes.
                </span>
            </div>

            <div v-if="showCustomerInfo" class="row mb-4">
                <div class="col-sm-5">
                    <div>
                        <AdvancedCustomerSearch label="Customer" :disabled="true" :readOnly="isReadOnly || !uncommitted" v-model="currentCustomer" @change="updateCustomerInfo" placeholder="Search..." class="mb-2" />
                        <div v-if="$v.currentCustomer.Id && $v.currentCustomer.Id.$error && $v.currentCustomer.Id.$dirty">
                            <div class="validation-error" >Customer is Required</div>
                        </div>
                        <div class="custom-area">
                            <table>
                                <tr>
                                    <td v-if="dealer && dealer.EnableCustomerType1 === true">
                                        <BasicTextInput :label="dealer.CustomerType1Label" :disabled="true" v-model="currentCustomer.CustomerType"/>
                                    </td>
                                    <td v-if="dealer && dealer.EnableCustomerType2 === true">
                                        <BasicTextInput :label="dealer.CustomerType2Label" :disabled="true" v-model="currentCustomer.CustomerType2"/>
                                    </td>
                                    <td v-if="dealer && dealer.EnableCustomerType3 === true">
                                        <BasicTextInput :label="dealer.CustomerType3Label" :disabled="true" v-model="currentCustomer.CustomerType3"/>
                                    </td>
                                    <td>
                                        <div v-for="iconObj in customIcons" :key="iconObj.IconURL">
                                            <div class="btn mr-2 p-1" :title="iconObj.IconLabel" v-if="iconObj.IconLabel === 'Coach+'"  style="margin-top: 20px">
                                                <img :src="iconObj.IconURL" @click="accessCoachPlus(iconObj)" :alt="iconObj.IconLabel" height="24px" >
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </div>

                        <AdvancedOrderSearch
                            :key="currentCustomer.Id"
                            label="Order"
                            :disabled="true"
                            :readOnly="false"
                            :currentCustomerId="currentCustomer.Id"
                            v-model="worksheetName"
                            @change="updateOrderInfo"
                            placeholder="Search..."
                            class="mb-2"
                            @orderPreviewRequested="orderPreviewRequested"
                        />

                        <!-- <BasicTextInput label="Order Number" :disabled="!uncommitted || isReadOnly" placeholder="ex: 12345" class="mb-2" /> -->

                        <table>
                            <tr>
                                <td>
                                    <div>
                                        <BasicDropdown v-if="orderTypeOptions.length > 0" label="Order Type" :key="orderType" v-model="orderType" :items="orderTypeOptions" :disabled="committed || submitted || isReadOnly" style="width: 275px; padding-right: 25px"/>
                                        <div v-if="(isHSUS || isHSCA) && orderTypeOptions.length > 0 && !orderType && uncommitted" class="validation-error">Order Type Must Be Set To Submit an Order</div>
                                    </div>
                                </td>
                                <td>
                                    <DatePicker :readOnly="isReadOnly || !uncommitted" @change="formChanged" v-model="paymentDueOn" label="Payment Due" />
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div class="date-area">
                        <table>
                            <tr>
                                <td>
                                    <div>
                                        <DatePicker label="Installation Date" :readOnly="isReadOnly || !uncommitted" v-model="installationDate" @change="formChanged()" class="mb-2" />
                                        <div v-if="$v.installationDate && $v.installationDate.$error && $v.installationDate.$dirty">
                                            <div class="validation-error" >Please select an installation date before committing</div>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div>
                                        <DatePicker label="Expiration Date" :readOnly="isReadOnly || !uncommitted" v-model="expirationDate"  @change="formChanged()" class="mb-2" />
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div class="col-sm-1">
                    &nbsp;
                </div>
                <div class="col-sm-6">
                    <tabs>
                        <tab title="Billing Info">
                            <div class="card" style="height: 380px">
                                <!--
                                <div class="card-header">
                                    <h5 class="card-title">Billing Information</h5>
                                    <hr>
                                </div>
                                -->
                                <div class="card-body">
                                    <div class="row mb-2">
                                        <div class="col">
                                            <BasicTextInput label="Company" :disabled="!uncommitted || isReadOnly" placeholder="Ex: Acme, Inc." v-model="billingAddress.Name" class="mb-2" />
                                        </div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-8">
                                            <BasicTextInput label="Address" :disabled="!uncommitted || isReadOnly" v-model="billingAddress.Line1" placeholder="Enter Address Line 1" />
                                        </div>
                                        <div class="col-4">
                                            <BasicTextInput label="Suite" :disabled="!uncommitted || isReadOnly" v-model="billingAddress.Line2" placeholder="Enter Address Line 2" />
                                        </div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col">
                                            <BasicTextInput label="City" :disabled="!uncommitted || isReadOnly" v-model="billingAddress.City"  placeholder="Enter City" />
                                        </div>
                                        <div class="col">
                                            <StateSelect  :disabled="!uncommitted || isReadOnly" v-model="billingAddress.StateId" :key="`billing-${billingAddress.StateId}-${billingStatesUpdateKey}`" :states="billingStates" label="State/Province"   />
                                        </div>
                                        <div class="col">
                                            <ZipCodeInput  :disabled="!uncommitted || isReadOnly"  label="Zip/Postal Code"   v-model="billingAddress.ZipCode"  placeholder="Enter Zip/Postal Code" />
                                        </div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col" :key="`billingCountry-${billingAddress.CountryId}`">
                                            <CountrySelect  :disabled="!uncommitted || isReadOnly" v-model="billingAddress.CountryId" @change="getStatesForCountryBilling" label="Country"   />
                                        </div>
                                        <div class="col-6">
                                            <BasicTextInput v-model="billingAddress.Contact" :disabled="!uncommitted || isReadOnly" label="Contact" />
                                        </div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-6">
                                            <PhoneNumberInput v-model="billingAddress.PhoneNumber" :disabled="!uncommitted || isReadOnly" label="Phone"></PhoneNumberInput>
                                        </div>
                                        <div class="col-6">
                                            <PhoneNumberInput v-model="billingAddress.FaxNumber" :disabled="!uncommitted || isReadOnly" label="Fax"></PhoneNumberInput>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </tab>
                        <tab title="Shipping Info">
                            <div class="card" style="height: 380px">
                                <div class="card-body">
                                    <ShipToDropdown :key="shippingAddress.AddressId" label="Ship to" :disabled="!uncommitted || isReadOnly" :currentCustomer="currentCustomer" :items="currentCustomer.Addresses" @change="updateShippingInfo" v-model="shippingAddress.AddressId" class="mb-2"/>
                                    <!-- <BasicTextInput v-if="!shippingAddress.LastUsedCustomerAddressId" label="Name" placeholder="Ex: Acme, Inc." :disabled="!uncommitted || isReadOnly" v-model="shippingAddress.Name"  /> -->
                                    <div class="row mb-2 mt-3">
                                        <div class="col-8">
                                            <BasicTextInput label="Address" v-model="shippingAddress.Line1" :disabled="!uncommitted || isReadOnly" placeholder="Enter Address Line 1" />
                                        </div>
                                        <div class="col-4">
                                            <BasicTextInput label="Suite"  v-model="shippingAddress.Line2" :disabled="!uncommitted || isReadOnly" placeholder="Enter Address Line 2" />
                                        </div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col">
                                            <BasicTextInput label="City"   v-model="shippingAddress.City" :disabled="!uncommitted || isReadOnly" placeholder="Enter City" />
                                        </div>
                                        <div class="col">
                                            <StateSelect    label="State/Province"   v-model="shippingAddress.StateId" :disabled="!uncommitted || isReadOnly" :key="`shipping-${shippingAddress.StateId}-${shippingStatesUpdateKey}`" :states="shippingStates" v-on:state-changed="shippingStateChanged"/>
                                        </div>
                                        <div class="col">
                                            <ZipCodeInput   label="Zip/Postal Code"   v-model="shippingAddress.ZipCode"  :disabled="!uncommitted || isReadOnly" placeholder="Enter Zip/Postal Code" />
                                        </div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col">
                                            <CountrySelect :key="`shippingCountry-${shippingAddress.CountryId}`" :disabled="!uncommitted || isReadOnly" v-model="shippingAddress.CountryId" @change="getStatesForCountryShipping" label="Country"   />
                                        </div>
                                        <div class="col-6">
                                            <BasicTextInput label="Contact" v-model="shippingAddress.Contact" :disabled="!uncommitted || isReadOnly"/>
                                        </div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-6">
                                            <PhoneNumberInput label="Phone" v-model="shippingAddress.PhoneNumber" :disabled="!uncommitted || isReadOnly"></PhoneNumberInput>
                                        </div>
                                        <div class="col-6">
                                            <PhoneNumberInput label="Fax" v-model="shippingAddress.FaxNumber" :disabled="!uncommitted || isReadOnly"></PhoneNumberInput>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </tab>
                        <tab title="Installation Info">
                            <div class="card" style="height: 380px">
                                <div class="card-body">
                                    <div class="row mb-2">
                                        <div class="col">
                                            <BasicTextInput label="Company" :disabled="!uncommitted || isReadOnly" placeholder="Ex: Acme, Inc." v-model="installAddress.Name" class="mb-2" />
                                        </div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-8">
                                            <BasicTextInput label="Address" :disabled="!uncommitted || isReadOnly" v-model="installAddress.Line1" placeholder="Enter Address Line 1" />
                                        </div>
                                        <div class="col-4">
                                            <BasicTextInput label="Suite" :disabled="!uncommitted || isReadOnly" v-model="installAddress.Line2" placeholder="Enter Address Line 2" />
                                        </div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col">
                                            <BasicTextInput label="City" :disabled="!uncommitted || isReadOnly" v-model="installAddress.City"  placeholder="Enter City" />
                                        </div>
                                        <div class="col">
                                            <StateSelect  :disabled="!uncommitted || isReadOnly" v-model="installAddress.StateId" :key="`billing-${installAddress.StateId}-${installStatesUpdateKey}`" :states="installStates" label="State/Province"   />
                                        </div>
                                        <div class="col">
                                            <ZipCodeInput  :disabled="!uncommitted || isReadOnly"  label="Zip/Postal Code"   v-model="installAddress.ZipCode"  placeholder="Enter Zip/Postal Code" />
                                        </div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col" :key="`installCountry-${installAddress.CountryId}`">
                                            <CountrySelect  :disabled="!uncommitted || isReadOnly" v-model="installAddress.CountryId" @change="getStatesForCountryInstall" label="Country"   />
                                        </div>
                                        <div class="col-6">
                                            <BasicTextInput v-model="installAddress.Contact" :disabled="!uncommitted || isReadOnly" label="Contact" />
                                        </div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-6">
                                            <PhoneNumberInput v-model="installAddress.PhoneNumber" :disabled="!uncommitted || isReadOnly" label="Phone"></PhoneNumberInput>
                                        </div>
                                        <div class="col-6">
                                            <PhoneNumberInput v-model="installAddress.FaxNumber" :disabled="!uncommitted || isReadOnly" label="Fax"></PhoneNumberInput>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </tab>
                    </tabs>
                </div>
            </div>

            <div class="row" style="margin-top: -15px">
                <div class="col-12">
                    <div class="d-flex justify-content-between">
                        <h4>Order Lines</h4>
                        <div class="d-flex ml-2 mr-2" :style="{minWidth: '180px'}">
                            <div class="m-0 p-0 row align-items-center">
                                <div class="mr-1 font-weight-bolder text-primary" >Detail View</div>
                                <label class="switch">
                                    <input v-model="detailView" @change="toggleDetailView" type="checkbox">
                                    <span class="slider round"></span>
                                </label>
                                <!-- <Toggle-Switch />  -->
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div :key="OrderGridUpdateKey" class="col grid-wrapper">
                        <CustomerOrderGrid
                            v-for="(bundle, index) in bundles"
                            :ref="'CustomerOrderGrid'"
                            :key="bundle.OrderLineGroupId"
                            :readOnly="!uncommitted || isReadOnly"
                            :dataSource="orderLinesSortedByLineNumber"
                            :OrderLineGroupName="bundle.OrderLineGroupName"
                            :OrderLineGroupId="bundle.OrderLineGroupId"
                            :bundleIsImported="bundle.IsImported"
                            :PrintOptionId="bundle.PrintOptionId"
                            :BundleQuantity="bundle.Quantity"
                            :printOptions="printOptions"
                            :sequenceOptions="sequenceOptions"
                            :gridIndex="index"
                            :roundToDollar="OrderSalesSettings.RoundToNearestDollar"
                            :showColumnLines="true"
                            :defaultGP="defaultGP"
                            @updateData="updateOrderLines"
                            @createNewBundle="createNewBundle"
                            @deleteBundle="deleteBundle"
                            @editBundle="editBundle"
                            @deleteBundleAndKeepOrderLines="deleteBundleAndKeepOrderLines"
                            @itemHasBeenAdded="formChanged"
                            :detailView="detailView"
                            :totalsSummary="totalsSummary[index]"
                            @updateTotalsValues="updateTotalsValues"
                            @updateOrderLineNumbers="updateOrderLineNumbers"
                            @addProductFromSmartCatalog="addProductFromSmartCatalog"
                            @addProductsFromConfigurator="addProductsFromConfigurator"
                            @pasteOrderLines="pasteOrderLines"
                            @appendAdecOrderLines="appendAdecOrderLines"

                            @copyOrderLines="copyOrderLines"
                            @cutOrderLines="cutOrderLines"
                            @refreshPricing="refreshPricing"
                            @deleteOrderLines="deleteOrderLines"
                            @selectAll="selectAll"
                            @deselectAll="deselectAll"
                            @applyBulkChanges="applyBulkChanges"
                            @moveBundleUp="moveBundleUp"
                            @moveBundleDown="moveBundleDown"
                        />
                    </div>
                </div>
            </div>
            <div  class="row mb-4"></div>
            <hr>
            <div class="lower-section">
                <div class="card">
                    <div class="card-header">
                        <h5 class="card-title">Order Representative</h5>
                        <hr>
                    </div>
                    <div class="card-body">
                        <SalesRepSelect v-model="ownerSalesRepId"  :disabled="!uncommitted || isReadOnly" class="mb-2" label="Order Owner"
                            :salesReps="salesReps" :key="ownerSalesRepId"/>
                            <div v-if="$v.ownerSalesRepId && $v.ownerSalesRepId.$error && $v.ownerSalesRepId.$dirty">
                                <div class="validation-error" >Please assign an owner rep</div>
                            </div>
                        <ColleagueSelect
                            v-model="AdditionalRepCode"
                            :name="AdditionalRepName"
                            v-if="dealer && dealer.ShowAdditionalRep1"

                            @updateName="updateRepName"
                            :isCombobox="dealer.AdditionalRepsAlternateDisplay"
                            colleagueSelectType="addRep1"
                            :disabled="!uncommitted || isReadOnly"
                            class="mb-2" label="Additional Rep 1"
                            :colleagues="additionalRepOneOptions"
                            :allColleagues="colleagues"
                            :key="'Rep1 - ' + AdditionalRepCode + '-' + AdditionalRepName"/>
                        <ColleagueSelect
                            v-model="AdditionalRep2Code"
                            :name="AdditionalRep2Name"
                            v-if="dealer && dealer.ShowAdditionalRep2"

                            @updateName="updateRepName"
                            :isCombobox="dealer.AdditionalRepsAlternateDisplay"
                            colleagueSelectType="addRep2"
                            :allColleagues="colleagues"
                            :disabled="!uncommitted || isReadOnly"
                            class="mb-2" label="Additional Rep 2"
                            :colleagues="additionalRepTwoOptions"
                            :key="'rep2-' + AdditionalRep2Code + ' - ' + AdditionalRep2Name"/>
                        <ColleagueSelect
                            v-model="EquipmentRepCode"
                            :name="EquipmentRepName"
                            v-if="dealer"

                            @updateName="updateRepName"
                            :isCombobox="dealer.AdditionalRepsAlternateDisplay"
                            colleagueSelectType="eqRep"
                            :allColleagues="colleagues"
                            :disabled="!uncommitted || isReadOnly"
                            class="mb-2"
                            label="Sales Rep"
                            :colleagues="salesRepOptions"
                            :key="`${EquipmentRepCode}-${EquipmentRepName}`"/>
                        <BasicTextInput :disabled="true" v-model="transferredRep" class="mb-2" label="Transferred From"
                            />
                    </div>
                </div>
                <div class="card summary">
                    <div class="card-header">
                        <h5 class="card-title">Order Summary</h5>
                        <hr>
                    </div>
                    <div class="card-body">
                        <CurrencyInput label="Subtotal" v-model="totals.subtotal" :disabled="true"  placeholder="" class="mb-2" />

                        <div class="row mb-2">
                            <CurrencyInputWithPercentAllowed label="Freight" :subtotal="totals.subtotal"  @change="freightChanged" @percentageInput="storeFreightPercent" v-model="totals.freight"   :disabled="!uncommitted || isReadOnly" placeholder="" class="col-8" />
                            <Checkbox label="Tax Freight" v-model="OrderSalesSettings.TaxFreight" @change="setTotals" class="col-4" style="margin-top: 30px;" :disabled="isHSUS || isZAHN"/>
                        </div>

                        <div class="row mb-2">
                            <div class="col-6"><PercentInput @change="setTotals"  :disabled="!uncommitted || isReadOnly" v-model="totals.salesTax" label="Sales Tax"  /></div>
                            <div class="col-6">
                                <CurrencyInput :disabled="true" v-model="totals.salesTaxAmount" placeholder="" />
                            </div>
                        </div>
                        <CurrencyInput label="Total"        v-model="totals.total"          :disabled="true"  placeholder="" class="mb-2" />
                        <CurrencyInputWithPercentAllowed label="Down Payment" :subtotal="totals.total" v-model="totals.downPayment" @percentageInput="storeDownPaymentPercent"  @change="downPaymentChanged"  :disabled="!uncommitted || isReadOnly" placeholder="" class="mb-2" />
                        <CurrencyInput label="Balance Due"  v-model="totals.balanceDue"     :disabled="true"  placeholder="" class="mb-2" />
                        <div v-if="detailView" class="p-0 m-0">
                            <div class="row mb-2">
                                <div class="col-6"><PercentInput :disabled="true" v-model="totals.discountPercent" label="Discount"  /></div>
                                <div class="col-6">
                                    <CurrencyInput :disabled="true" v-model="totals.discount" placeholder="" />
                                </div>
                            </div>
                            <!-- <CurrencyInput label="Discount"     v-model="totals.discount"   :disabled="true" placeholder="" class="mb-2" /> -->
                            <CurrencyInput label="Dealer Cost"  v-model="totals.dealerCost" :disabled="true" placeholder="" class="mb-2" />
                            <CurrencyInput label="Profit"       v-model="totals.profit"     :disabled="true" placeholder="" class="mb-2" />

														<div class=row mb-2>
															<div class="col-6">
                            		<PercentInput  label="Order GP"    v-model="totals.actualGP"   :disabled="true" placeholder="" class="mb-2" />
															</div>
															<div class="col-6">
																<div v-if="(isHSUS || isZAHN) && businessVersion >= 2">
																	<PercentInput label="Commissionable GP" v-model="totals.commissionableGP" :disabled="true" placeholder="" class="mb-2" />
																</div>
															</div>
														</div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <tabs>
                        <tab title="General Notes">
                            <div class="card-header">
                                <h5 class="card-title">General Notes</h5>
                                <hr>
                            </div>
                            <div class="card-body">
                                <TextAreaInput  :disabled="!uncommitted || isReadOnly" v-model="generalNotes"/>
                                <div v-if="generalNotes">
                                    <div v-if="generalNotes.length > maxNotesLength" class="validation-error">{{generalNotes.length}}/{{maxNotesLength}}</div>
                                    <!-- <div v-if="generalNotes.length <= maxNotesLength" class="validation-success">{{generalNotes.length}}/{{maxNotesLength}}</div> -->
                                </div>
                            </div>
                        </tab>
                        <tab title="Confidential Notes" v-if="detailView">
                            <div v-if="detailView" class="card">
                                <div class="card-header">
                                    <h5 class="card-title">Confidential Notes</h5>
                                    <hr>
                                </div>
                                <div class="card-body">
                                    <TextAreaInput :disabled="!uncommitted || isReadOnly" v-model="confidentialNotes" />
                                    <div v-if="confidentialNotes">
                                        <div v-if="confidentialNotes.length > maxNotesLength" class="validation-error">{{confidentialNotes.length}}/{{maxNotesLength}}</div>
                                        <!-- <div v-if="confidentialNotes.length <= maxNotesLength" class="validation-success">{{confidentialNotes.length}}/{{maxNotesLength}}</div> -->
                                    </div>
                                </div>
                            </div>
                        </tab>
                    </tabs>
                </div>
            </div>

            <div class="row mt-4 mb-5">
                <div class="col-4 offset-8 lower-level-order-btns__right">
                    <!-- <button class="btn btn-lg btn-secondary">Cancel</button> -->
                    <div class="btn btn-lg btn-primary" v-if="uncommitted && !isReadOnly" @click="saveOrder" >Save</div>
                </div>
            </div>

        </form>
        <Modal ref="deleteOrderModal">
            <div class="card modal-wrapper p-4">
                <p class="modal-text">Are you sure you would like to delete this order?</p>
                <div class="btn-wrapper center">
                    <button class="btn btn-secondary" @click="toggleDeleteModal">Cancel</button>
                    <button @click="deleteOrder" class="btn btn-primary">Delete</button>
                </div>
            </div>
        </Modal>
        <Modal ref="commitOrderModal">
            <div class="card modal-wrapper p-4">
                <p class="modal-text">Once you commit your order, no changes can be made. Please confirm you wish to commit the order.</p>
                <div class="btn-wrapper center">
                    <button class="btn btn-secondary" @click="toggleCommitModal">Cancel</button>
                    <button @click="saveAndCommitOrder" class="btn btn-primary">Commit</button>
                </div>
            </div>
        </Modal>
        <Modal ref="newOrderModal">
            <div class="card modal-wrapper p-4">
                <p class="modal-text">Would you like to save the current order?</p>
                <!-- <p class="mt-0 ">to delete this order?</p> -->
                <div class="btn-wrapper center">
                    <button class="btn btn-secondary" @click="createNewOrder">No, do not save</button>
                    <button @click="saveAndCreateNewOrder" class="btn btn-primary">Yes</button>
                </div>
            </div>
        </Modal>
        <Modal ref="uncommitOrderModal">
            <div class="card modal-wrapper p-4">
                <p class="modal-text">Are you sure you would like to uncommit this order?</p>
                <div class="btn-wrapper center">
                    <button class="btn btn-secondary" @click="toggleUncommitModal">Cancel</button>
                    <button @click="uncommitOrder" class="btn btn-primary">Uncommit</button>
                </div>
            </div>
        </Modal>
        <Modal ref="importSmartSalesOrderModal">
            <div class="card modal-wrapper p-4" style="width: 500px">
                <div class="card-header">
                    <h5 class="card-title">Load Saved Order</h5>
                    <hr>
                </div>
                <div class="card-body" style="overflow-x: hidden;">
                    <input
                        id="smartSalesImportFile"
                        type="file"
                        accept=".json,application/JSON"
                        @change="smartSalesImportFileSelected"
                        style="width:400px">

                    <div style="margin-top: 15px; margin-bottom: 15px;">
                        <Checkbox label="Create New Order" @change="isCreateNewOrderChanged" v-model="isCreateNewOrder"/>
                        <Checkbox label="Add Order Lines to Current Order" @change="isAddToExistingOrderChanged" v-model="isAddToExistingOrder"/>
                    </div>

                    <div class="btn-wrapper center">
                        <button class="btn btn-secondary" @click="toggleImportSmartSalesOrderModal">Cancel</button>
                        <button @click="importSmartSalesFileSelected" :disabled="!smartSalesImportFile" class="btn btn-primary">Load</button>
                    </div>
                </div>
            </div>
        </Modal>
        <Modal ref="importAdecOrderModal">
            <div class="card modal-wrapper p-4">
                <div class="card-header">
                    <h5 class="card-title">Import</h5>
                    <hr>
                </div>
                <div class="card-body">
                    <input type="file" accept="application/XML" @change="adecImportFileSelected" >
                    <BasicDropdown label="Print Options" class="my-3" :items="importedPrintOptionsItems" v-model="adecImportPrintOption"/>
                    <Checkbox label="Ignore items with Retail of $0" v-model="ignoreZeroRetail" />
                    <Checkbox label="Import Quote Pricing (no DB Lookup)" v-model="importQuotePricing" :disabled="dealer && dealer.AllowQuotePricing !== true"/>
                    <div class="btn-wrapper center">
                        <button class="btn btn-secondary" @click="toggleImportAdecOrderModal">Cancel</button>
                        <button @click="importFileSelected" class="btn btn-primary">Import</button>
                    </div>
                </div>
            </div>
        </Modal>

        <Modal ref="orderPreviewDialog">
					<OrderPreview :orderId="selectedOrderId"/>
        </Modal>

        <Modal ref="concurrencyConflictModal">
            <div class="card modal-wrapper p-4" style="width: 600px">
                <div class="card-header">
                    <h5 class="card-title">Save Not Executed</h5>
                    <hr>
                </div>
                <div class="card-body">
                    <p class="modal-text">The version of this order you loaded has been superseded by another user's save. You should not attempt to edit an order at the same time it is opened by another user. If you are an admin or manager, it is better to reassign orders to yourself before editing.</p>
                </div>
                <div class="btn-wrapper center">
                    <button class="btn btn-primary" @click="closeConcurrencyModal">OK</button>
                </div>
            </div>
        </Modal>

				<Modal ref="formBuilderDialog">
					<FormBuilder
						:reportTypes="reportTypes"
						:orderNumber="orderNumber"
						:billingAddressName="billingAddress.Name"
						:dealerType = "dealerType"
						:installationDate="installationDate"
						:expirationDate="expirationDate"
						:isSubmitted="submitted"
            @generate="onGenerateForms"
					/>
				</Modal>

        <Modal ref="orderLinkNextStepsDialog">
            <OrderLinkNextStepsDialog :url="orderLinkUrl"/>
        </Modal>

				<Modal ref="calculationErrorDialog">
					<div class="card modal-wrapper p-4">
							<div class="card-header">
									<h5 class="card-title">Order Error</h5>
									<hr>
							</div>
							<div class="card-body">
								<div>
									We detected outdated information.  Please Save then refresh this browser window.
								</div>
								<div>
									Contact support if this message is repeated on this order.
								</div>
								<div v-if="uncommitted && !isReadOnly" class="btn-wrapper center">
										<button @click="saveAndRefreshOrder" class="btn btn-primary">Save & Refresh</button>
								</div>
								<div v-else class="btn-wrapper center">
										<button @click="saveAndRefreshOrder" class="btn btn-primary">Refresh</button>
								</div>
							</div>
          </div>
				</Modal>

        <Modal ref="transferOrderModal">
            <div class="card modal-wrapper p-4" style="min-width: 350px">
                <div class="card-header">
                    <h5 class="card-title">Transfer Order</h5>
                    <hr>
                </div>
                <div class="card-body">
                    <p class="modal-text">Select a sales rep to transfer this order to:</p>
                    <select class="form-control mb-3" v-model="selectedTransferRepId">
                        <option :value="null" disabled>-- Select Sales Rep --</option>
                        <option v-for="rep in salesReps" :key="rep.SalesRepId" :value="rep.SalesRepId">
                            {{ rep.FirstName }} {{ rep.LastName }}
                        </option>
                    </select>
                </div>
                <div class="btn-wrapper center">
                    <button class="btn btn-secondary" @click="$refs.transferOrderModal.toggle()">Cancel</button>
                    <button @click="confirmTransfer" class="btn btn-primary" :disabled="!selectedTransferRepId">Transfer</button>
                </div>
            </div>
        </Modal>

        <!-- <Modal ref="routeGuardModal">
            <div class="card modal-wrapper p-4">
                <p class="m-0">Would you like to save you changes</p>
                <p class="mt-0 ">before leaving the page?</p>
                <div class="btn-wrapper center">
                    <button class="btn btn-secondary" @click="toggleRouteGuardModal">Cancel</button>
                    <button @click="uncommitOrder" class="btn btn-primary">No, delete changes</button>
                    <button @click="uncommitOrder" class="btn btn-primary">Yes, save changes</button>
                </div>
            </div>
        </Modal>       -->
    </div>
</template>

<script>
    import moment                           from 'moment';
    import { mapState }                     from 'vuex';
    import { userRoleEnum, getKeyByValue }  from "../../../modules/helpers";
    import { CustomerOrderGrid }            from '@/components'
    import AdvancedCustomerSearch           from '../../../components/AdvancedCustomerSearch';
    import AdvancedOrderSearch              from '../../../components/AdvancedOrderSearch';
    import ShipToDropdown                   from '../../../components/inputComponents/ShipToDropdown';
    import CountrySelect                    from '../../../components/inputComponents/CountrySelect';
    import CurrencyInputWithPercentAllowed  from '../../../components/inputComponents/CurrencyInputWithPercentAllowed';

    import FavoriteIndicator from '../../../components/inputComponents/FavoriteIndicator';

    import {
        OrderService,
        DealerService,
        OrderPrintOptionsService,
        UserService,
        CoworkerService,
        CustomerService,
        ProductService,
        ReportService,
        CountryService,
    } from '@/services';

    import { validatorMsgMapBase } from "../../../modules/helpers.js";
    import { required, maxLength } from 'vuelidate/lib/validators';
    import { Tabs, Tab } from 'vue-slim-tabs';
    import Checkbox from '../../../components/inputComponents/Checkbox.vue';
    import OrderPreview from '../../../components/OrderPreview.vue';
		import FormBuilder from '../../../components/FormBuilder.vue';
		import OrderLinkNextStepsDialog from '../../../components/OrderLinkNextSteps.vue';

    // let orders = getDataSource('Orders')

    const COUNTRY_ID_CANADA = 2;
		const CURRENT_ORDER_BUSINESSVERSION = 2;

    export default {
        name: "CustomerOrder",
        components: {
            CustomerOrderGrid,
            AdvancedCustomerSearch,
            AdvancedOrderSearch,
            ShipToDropdown,
            CurrencyInputWithPercentAllowed,
            CountrySelect,
            Checkbox,
            Tabs,
            Tab,
            OrderPreview,
						FormBuilder,
						FavoriteIndicator,
						OrderLinkNextStepsDialog,
        },
        data: () => {
            return {
                favoritesKey: 0,
                isLimitedTransferUser: true,
                billingStatesUpdateKey: 100000000,
                shippingStatesUpdateKey: 1000000,
                installStatesUpdateKey: 1000,
                adecImportPrintOption: null,
                adecImportFile: null,
                smartSalesImportFile: null,
                ignoreZeroRetail: true,
                importQuotePricing: false,
                equipmentType: null,
                orderType: null,
                orderTypeOptions: [],
                // importedFile: null,
                validatorMsgMapBase: validatorMsgMapBase,
                detailView: false,
                loading: false,
                showCustomerInfo: true,
                isReadOnly: false,
                isHistoricalView: false,
                historicalAsOfTime: null,
                isSaving: false,
                isHSUS: false,
                isHSCA: false,
								isZAHN: false,
								dealerType: '',
                // dealerSalesTaxInfo: {},
                currentCustomer: {},
                worksheetName: '',
                installationDate: null,
                expirationDate: null,
                emptyAddress: {
                    Line1: '',
                    Line2: '',
                    City: '',
                    StateId: null,
                    CountryId: 1, //USA
                    PostalCode: '',
                    PhoneNumber: '',
                    FaxNumber: '',
                    Contact: '',
                    LocationCode: '',
                    AddressId: null,
                },
                billingAddress: {},
                shippingAddress: {},
                installAddress: {},
                generalNotes: '',
                confidentialNotes: '',
                maxNotesLength: 1000,
                paymentDueOn: null,
                defaultCustomer: {
                    Id: null,
                    JdeNum: '',
                    Name: '',
                    PhoneNum: '',
                    FaxNumber: '',
                    LicenseNumber: null,
                    Specialty: null,
                    CustomerContact: {
                        FirstName: '',
                        LastName: '',
                        PhoneNumber: '',
                        Email: null,
                    },
                    Address: {
                        AddressId: 0,
                        Name: '',
                        Line1: '',
                        Line2: '',
                        City: '',
                        StateId: null,
                        ZipCode: '',
                        Contact: '',
                        LocationCode: '',
                    },
                    IsPrivate: true
                },
                totals: {},
                creationDate: moment().format('L'),
                creationTime: moment().format('LTS'),
                revisionDate: moment().format('L'),
                revisionTime: moment().format('LTS'),
                committedDate: moment().format('L'),
                committedTime: moment().format('LTS'),
                submittedDate: moment().format('L'),
                submittedTime: moment().format('LTS'),
                bundles: [{OrderLineGroupName: 'Individual Line Items', OrderLineGroupId: 0, Id: null, PrintOptionId: 4}],
                orderLines: [],
                OrderGridUpdateKey: 0,
                defaultFreightPercent: 0,
                defaultDownPaymentPercent: 10,
                CustomFreight: false,
                CustomDownPayment: false,
                customerJde: null,
                orderNumber: '',
                emptyTotal: {
                    id: 0,
                    subtotal: 0,
                    retail: 0,
                    freight: 0,
                    salesTax: 7,
                    isFreightPercent: true,
                    salesTaxAmount: 0,
                    total:0,
                    downPayment: 0,
                    balanceDue: 0,
                    discount: 0,
                    dealerCost: 0,
                    profit: 0,
                    actualGP: 0,
										commissionableGP: 0,
                },
                totalsSummary: [],
                //currentSavedOrder: {}
                ownerSalesRepId: null,
                // orderId: 0,
                orderStatusId: 1,
                EquipmentRepCode: null,
                AdditionalRepCode: null,
                AdditionalRep2Code: null,
                EquipmentRepName: null,
                AdditionalRepName: null,
                AdditionalRep2Name: null,
                transferredSalesRepId: null,
                salesReps: [],
                isRestrictedSalesAdmin: false,
                showTransferModal: false,
                selectedTransferRepId: null,
                colleagues: [],
                products: [],
                reportTypes: [],
                defaultGP: 0,
                OrderSalesSettings: {},
                printOptions: [],
                defaultRepSalesTax: null,
                avoidRouteGuard: false,
                // orders,
                formHasBeenChanged: false,
                billingStates: null,
                shippingStates: null,
                installStates: null,
                dealer: null,
                saveWarningInterval: null,
                regionFinanceRates: null,
                customIcons: [],
                isAddToExistingOrder: false,
                isCreateNewOrder: true,
                selectedOrderId: 0,
								orderLinkUrl: '',
								businessVersion: CURRENT_ORDER_BUSINESSVERSION,
								originalBusinessVersion: 0,
                rowVersion: null,
            }
        },
        validations() {
            return {
                currentCustomer: {
                    Id: {
                        customerRequired: required,
                    },
                },
                ownerSalesRepId: {
                    required
                },
                generalNotes: {
                    maxLength: maxLength(1000)
                },
                confidentialNotes: {
                    maxLength: maxLength(1000)
                },

                installationDate: {
                    required
                },

            }
        },
        methods: {
            formBuilder() {
                this.$refs.formBuilderDialog.openModal();
            },
            orderPreviewRequested(id) {
                this.selectedOrderId = id;
                this.$refs.orderPreviewDialog.openModal();
            },
            updateRepName(name, type){
                if(type === 'addRep1'){
                    this.AdditionalRepName = name || null;
                } else if(type === 'addRep2'){
                    this.AdditionalRep2Name = name || null;
                } if(type === 'eqRep'){
                    this.EquipmentRepName = name || null;
                }
            },
            saveWorksheetName(){
                this.formChanged();
                if(this.uncommitted) return;
                OrderService.saveWorksheetName({OrderId: this.$route.params.id, Name: this.worksheetName, RowVersion: this.rowVersion})
                    .then(() => {
                        this.$store.dispatch('ADD_NOTIFICATION', { text: `Worksheet name updated`, type: 'success' });
                    })
                    .catch((err) => {
                        if (err.response?.status === 409) {
                            this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.message || 'This order was modified by another user. Please refresh the page.', type: 'error' });
                        } else {
                            this.$store.dispatch('ADD_NOTIFICATION', { text: `Unable to update worksheet name`, type: 'error' });
                        }
                    })
            },
            toggleDetailView(){
                localStorage.setItem('detailView', this.detailView);
            },
            getOrderTypeOptions(){
                this.orderTypeOptions = []
                DealerService.orderTypes()
                    .then(res => {
                        if (res && res.length > 0) {
                            this.orderTypeOptions = [{text: '', value: null}]
                            res.forEach(option => {
                                this.orderTypeOptions.push({text: option.DisplayName, value: option.Id})
                            })
                        }
                        // this.orderTypeOptions = this.orderTypeOptions.concat([...res]);
                    });
            },
            getStatesForCountryBilling(e){
                CountryService.states(Number(e.target.value))
                    .then(res => {
                        this.billingStatesUpdateKey++;
                        this.billingStates = res;
                        if(!e.target.mimic) this.billingAddress.StateId = null;
                    });
            },
            getStatesForCountryInstall(e){
                CountryService.states(Number(e.target.value))
                    .then(res => {
                        this.installStatesUpdateKey++;
                        this.installStates = res;
                        if(!e.target.mimic) this.installAddress.StateId = null;
                    });
            },
            shippingStateChanged(e) {
                this.computeSalesTaxRate()
            },
            computeSalesTaxRate() {
                if (this.dealer.StoreCode === 'HSCA') {
                    if (this.shippingAddress.CountryId == COUNTRY_ID_CANADA) {
                        const regionCode = this.getRegionCodeFromStateId(this.shippingAddress.StateId)
                        const rate = this.regionFinanceRates.find(x => x.RegionKey === regionCode)
                        if (rate) {
                            this.totals.salesTax = (rate.Rate1 + rate.Rate2) * 100
                            this.totals.salesTaxAmount = this.calculateTax()
                        }
                    }
                }
            },
            getRegionCodeFromStateId(id) {
                const state = this.shippingStates.find(x => x.Id == id)
                if (state) return state.DisplayName
                return ''
            },
            getStatesForCountryShipping(e){
                CountryService.states(Number(e.target.value))
                    .then(res => {
                        this.shippingStatesUpdateKey++;
                        this.shippingStates = res;
                        if(!e.target.mimic) this.billingAddress.StateId = null;
                    });
            },
            sortBundles(){
                return this.bundles.sort(function(a, b) {
                    var idA = a.OrderLineGroupId;
                    var idB = b.OrderLineGroupId;
                    return (idA < idB) ? -1 : (idA > idB) ? 1 : 0;
                });
            },
            moveUpOrderLineBundleIds(bundleId){
                this.orderLines.forEach(line => {
                    if (line.OrderLineGroupId === bundleId-1 ){
                        line.OrderLineGroupId++;
                    } else if(line.OrderLineGroupId === bundleId){
                        line.OrderLineGroupId--;
                    }
                })
            },
            moveDownOrderLineBundleIds(bundleId){
                this.orderLines.forEach(line => {
                    if(line.OrderLineGroupId === bundleId){
                        line.OrderLineGroupId++;
                    } else if (line.OrderLineGroupId === bundleId+1 ){
                        line.OrderLineGroupId--;
                    }
                })
            },
            repositionOrderLineBundleIds(oldBundleId, newBundleId){
                if(oldBundleId > newBundleId){
                    this.orderLines.forEach((orderLine, index) => {
                        if( orderLine.OrderLineGroupId >= newBundleId && orderLine.OrderLineGroupId < oldBundleId){
                            orderLine.OrderLineGroupId++;
                        } else if(orderLine.OrderLineGroupId === oldBundleId){
                            orderLine.OrderLineGroupId = newBundleId
                        }
                    })
                } else if(oldBundleId < newBundleId){
                    this.orderLines.forEach((orderLine, index) => {
                        if(orderLine.OrderLineGroupId === oldBundleId){
                            orderLine.OrderLineGroupId = newBundleId
                        } else if( orderLine.OrderLineGroupId <= newBundleId && orderLine.OrderLineGroupId > oldBundleId){
                            orderLine.OrderLineGroupId--;
                        }
                    })
                }
            },
            repositionBundles(oldBundleId, newBundleId){
                if(oldBundleId > newBundleId){
                    this.bundles.forEach((bundle, index) => {
                        if( bundle.OrderLineGroupId >= newBundleId && bundle.OrderLineGroupId < oldBundleId){
                            bundle.OrderLineGroupId++;
                        } else if(bundle.OrderLineGroupId === oldBundleId){
                            bundle.OrderLineGroupId = newBundleId
                        }
                    })
                    this.totalsSummary.forEach((bundle, index) => {
                        if( bundle.id >= newBundleId && bundle.id < oldBundleId){
                            bundle.id++;
                        } else if(bundle.id === oldBundleId){
                            bundle.id = newBundleId
                        }
                    })
                } else if(oldBundleId < newBundleId){
                    this.bundles.forEach((bundle, index) => {
                        if(bundle.OrderLineGroupId === oldBundleId){
                            bundle.OrderLineGroupId = newBundleId
                        } else if( bundle.OrderLineGroupId <= newBundleId && bundle.OrderLineGroupId > oldBundleId){
                            bundle.OrderLineGroupId--;
                        }
                    })
                    this.totalsSummary.forEach((bundle, index) => {
                        if(bundle.id === oldBundleId){
                            bundle.id = newBundleId
                        } else if( bundle.id <= newBundleId && bundle.id > oldBundleId){
                            bundle.id--;
                        }
                    })
                }
                this.repositionOrderLineBundleIds(oldBundleId, newBundleId);
                this.bundles = this.sortBundles();
                this.OrderGridUpdateKey++;
            },
            moveBundleUp(bundleId){
                if(bundleId === 1) return;
                this.bundles.forEach((bundle, index) => {
                    if(!index) return;
                    if (bundle.OrderLineGroupId === bundleId-1 ){
                        bundle.OrderLineGroupId++;
                    } else if(bundle.OrderLineGroupId === bundleId){
                        bundle.OrderLineGroupId--;
                    }
                })
                this.totalsSummary.forEach((bundle, index) => {
                    if(!index) return;
                    if (bundle.id === bundleId-1 ){
                        bundle.id++;
                    } else if(bundle.id === bundleId){
                        bundle.id--;
                    }
                })
                this.moveUpOrderLineBundleIds(bundleId)
                this.bundles = this.sortBundles()
                this.OrderGridUpdateKey++

            },
            moveBundleDown(bundleId){
                if(bundleId === this.bundles.length - 1) return;
                this.bundles.forEach((bundle, index) => {
                    if(!index) return;
                    if(bundle.OrderLineGroupId === bundleId){
                        bundle.OrderLineGroupId++;
                    } else if (bundle.OrderLineGroupId === bundleId+1 ){
                        bundle.OrderLineGroupId--;
                    }
                })
                this.totalsSummary.forEach((bundle, index) => {
                    if(!index) return;
                    if(bundle.id === bundleId){
                        bundle.id++;
                    } else if (bundle.id === bundleId+1 ){
                        bundle.id--;
                    }
                })
                this.moveDownOrderLineBundleIds(bundleId)
                this.bundles = this.sortBundles()
                this.OrderGridUpdateKey++

            },
            storeDownPaymentPercent(percent){
                this.defaultDownPaymentPercent = Number(percent)
                this.setTotals()
            },
            selectAll(){
                this.$refs.CustomerOrderGrid.forEach(grid => {
                    grid.selectAll()
                })
            },
            deselectAll(){
                this.$refs.CustomerOrderGrid.forEach(grid => {
                    grid.deselectAll()
                })
            },

            cutOrderLines(){
                let rows = []
                this.$refs.CustomerOrderGrid.forEach(grid => {
                    rows = rows.concat(grid.getSelectedRowsData())
                    rows = rows.sort(function(a,b){ return a.LineNumber - b.LineNumber; })
                })
                if(rows.length <= 0){
                    this.$store.dispatch('ADD_NOTIFICATION', { text: `Please select rows you would like to copy using the checkbox`, type: 'warning' });
                    return
                }
                let numberOfRows = rows.length
                const stringifiedRows = JSON.stringify(rows)
                localStorage.setItem('rows', stringifiedRows);


                rows.sort(function(a,b){ return b.LineNumber - a.LineNumber; })
                for (var i = rows.length -1; i >= 0; i--){
                    let index = this.orderLines.map(orderLine => orderLine.LineNumber).indexOf(rows[i].LineNumber)
                    this.orderLines.splice(index,1);
                }

                this.updateOrderLineNumbers();

                this.$refs.CustomerOrderGrid.forEach(grid => {
                    grid.clearSelectedRows();
                    grid.datagridUpdateKey++;
                })
                this.$store.dispatch('ADD_NOTIFICATION', { text: `${numberOfRows} row(s) copied`, type: 'success' });
            },
            copyOrderLines(){
                let rows = []
                this.$refs.CustomerOrderGrid.forEach(grid => {
                    rows = rows.concat(grid.getSelectedRowsData())
                    rows = rows.sort(function(a,b){ return a.LineNumber - b.LineNumber; })
                    grid.clearSelectedRows();
                })
                if(rows.length <= 0){
                    this.$store.dispatch('ADD_NOTIFICATION', { text: `Please select rows you would like to copy using the checkbox`, type: 'warning' });
                    return
                }
                let numberOfRows = rows.length
                rows = JSON.stringify(rows)

                localStorage.setItem('rows', rows);
                this.$store.dispatch('ADD_NOTIFICATION', { text: `${numberOfRows} row(s) copied`, type: 'success' });

            },
            applyBulkChanges(changes) {
                // Get all selected rows from all grids
                let allSelectedRows = [];
                this.$refs.CustomerOrderGrid.forEach(grid => {
                    allSelectedRows = allSelectedRows.concat(grid.getSelectedRowsData());
                });

                if (allSelectedRows.length === 0) {
                    this.$store.dispatch('ADD_NOTIFICATION', { text: `No rows selected`, type: 'warning' });
                    return;
                }

                // Apply changes to all selected rows across all grids
                this.$refs.CustomerOrderGrid.forEach(grid => {
                    grid.applyBulkChangesToGrid(changes);
                });
            },
            refreshPricing(refreshAll = false) {
                let rows = []

								if (refreshAll) {
									rows = this.orderLines
								}
								else {
									this.$refs.CustomerOrderGrid.forEach(grid => {
											rows = rows.concat(grid.getSelectedRowsData())
									})
								}

                OrderService.refreshPricing(rows)
                    .then(res => {
                        res.forEach(line => {
                            let index = this.orderLines.map(row => row.LineNumber).indexOf(line.LineNumber)
                            if(index >= 0){
                                line.GPPercent = this.defaultGP;
                                line.InitialDealerCost = line.DealerCost;
                                if(!line.CustomerCost && this.defaultGP){
                                    if(line.DealerCost){
                                        line.CustomerCost = this.round(-(line.DealerCost/((this.defaultGP / 100) - 1)));
                                    } else {
                                        line.CustomerCost = 0;
                                    }
                                } else if(!line.CustomerCost){
                                    line.CustomerCost = this.round(line.Retail);
                                }
                                // line.CustomerCost = !line.CustomerCost || line.Retail
                                this.orderLines[index] = line;
                                this.$refs.CustomerOrderGrid[0].setCalculatedValues({data: this.orderLines[index]})
                                // this.$refs[`${this.refName}`].instance.saveEditData()
                            }
                        })
                        // this.refreshPricingFinished()
                        this.OrderGridUpdateKey++;
                    })
                    .catch(err => {
                        this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message, type: 'error' });
                    })
                    .finally(() => {
												this.OrderGridUpdateKey++;
												this.$refs.CustomerOrderGrid.forEach(grid => {
                            grid.refreshPricingFinished()
                        })
                    })
            },
            deleteOrderLines(){
                let rows = []
                this.$refs.CustomerOrderGrid.forEach(grid => {
                    rows = rows.concat(grid.getSelectedRowsData())
                })
                rows.sort(function(a,b){ return b.LineNumber - a.LineNumber; })
                for (var i = rows.length -1; i >= 0; i--){
                    let index = this.orderLines.map(orderLine => orderLine.LineNumber).indexOf(rows[i].LineNumber)
                    this.orderLines.splice(index,1);
                }
                this.$refs.CustomerOrderGrid.forEach(grid => {
                    grid.clearSelectedRows();
                    grid.datagridUpdateKey++;
                })
            },
            adecImportFileSelected($event){
                this.adecImportFile = $event;
            },
            smartSalesImportFileSelected($event){
                this.smartSalesImportFile = $event;
            },
            toggleImportAdecOrderModal(){
                this.$refs.importAdecOrderModal.toggle()
            },
            toggleImportSmartSalesOrderModal() {
                if (!this.$refs.importSmartSalesOrderModal.open) {
                    this.smartSalesImportFile = null;
                    this.isAddToExistingOrder = false;
                    this.isCreateNewOrder = true;
                }

                this.$refs.importSmartSalesOrderModal.toggle()
            },
            isAddToExistingOrderChanged() {
                this.isCreateNewOrder = !this.isAddToExistingOrder
            },
            isCreateNewOrderChanged() {
                this.isAddToExistingOrder = !this.isCreateNewOrder
            },
            getEquipmentRep(){
                // Only search for colleague if EquipmentRepCode is not null/undefined
                if (!this.EquipmentRepCode) {
                    return {
                        Title: null,
                        Name: this.EquipmentRepName,
                        FirstName: null,
                        LastName: null,
                        Email: null,
                        Phone: null,
                        Id: null,
                    }
                }

                let index = this.colleagues.map(colleague => colleague.Code).indexOf(this.EquipmentRepCode);
                if(index < 0){
                    return {
                        Title: null,
                        Name: this.EquipmentRepName,
                        FirstName: null,
                        LastName: null,
                        Email: null,
                        Phone: null,
                        Id: null,
                    }
                } else {
                    let eqrep = this.colleagues[index];
                    return{
                        Title: eqrep.Title,
                        Name: eqrep.FirstName + " " + eqrep.LastName,
                        FirstName: eqrep.FirstName,
                        LastName: eqrep.LastName,
                        Email: eqrep.Email,
                        Phone: eqrep.Phone,
                        Id: eqrep.Id,
                    }
                }
            },
            getAdditionalRep(){
                // Only search for colleague if AdditionalRepCode is not null/undefined
                if (!this.AdditionalRepCode) {
                    return {
                        Title: null,
                        Name: this.AdditionalRepName,
                        FirstName: null,
                        LastName: null,
                        Email: null,
                        Phone: null,
                        Id: null,
                    }
                }

                let index = this.colleagues.map(colleague => colleague.Code).indexOf(this.AdditionalRepCode);
                if(index < 0){
                    return {
                        Title: null,
                        Name: this.AdditionalRepName,
                        FirstName: null,
                        LastName: null,
                        Email: null,
                        Phone: null,
                        Id: null,
                    }
                } else {
                    let addrep = this.colleagues[index];
                    return{
                        Title: addrep.Title,
                        Name: addrep.FirstName + " " + addrep.LastName,
                        FirstName: addrep.FirstName,
                        LastName: addrep.LastName,
                        Email: addrep.Email,
                        Phone: addrep.Phone,
                        Id: addrep.Id,
                    }
                }
            },
            getAdditionalRep2(){
                // Only search for colleague if AdditionalRep2Code is not null/undefined
                if (!this.AdditionalRep2Code) {
                    return {
                        Title: null,
                        Name:this.AdditionalRep2Name,
                        FirstName: null,
                        LastName: null,
                        Email: null,
                        Phone: null,
                        Id: null,
                    }
                }

                let index = this.colleagues.map(colleague => colleague.Code).indexOf(this.AdditionalRep2Code);
                if(index < 0){
                    return {
                        Title: null,
                        Name:this.AdditionalRep2Name,
                        FirstName: null,
                        LastName: null,
                        Email: null,
                        Phone: null,
                        Id: null,
                    }
                } else {
                    let addrep = this.colleagues[index];
                    return{
                        Title: addrep.Title,
                        Name: addrep.FirstName + " " + addrep.LastName,
                        FirstName: addrep.FirstName,
                        LastName: addrep.LastName,
                        Email: addrep.Email,
                        Phone: addrep.Phone,
                        Id: addrep.Id,
                    }
                }
            },
            formChanged(){
                if(this.openRequestCount) {
                    // this isn't the best solution. The first change is due to the page loading and populating data and I want to ignore that.
                    return;
                }
                this.formHasBeenChanged = true;
                this.avoidRouteGuard = false;
            },
            resetBundleTotals(){
                if(this.orderLines.length <= 0) return;
                this.totalsSummary = []
                this.bundles.forEach(bundle => {
                    this.totalsSummary.push({...this.emptyTotal, id: bundle.OrderLineGroupId})
                })
                // this.OrderGridUpdateKey++;
            },
            addProductsFromConfigurator(newOrderLines){
                newOrderLines.forEach(line=> {
                    this.orderLines.push(line);
                })
                // this.OrderGridUpdateKey++;
            },
            addProductFromSmartCatalog(newOrderLine){
                // newOrderLine.LineNumber = this.orderLines.length;
                this.orderLines.push(newOrderLine);
            },
            appendAdecOrderLines(orderLines){
                this.orderLines = this.orderLines.concat([...orderLines]);

                this.reloadOrderLines();
                this.setTotals();
            },
            importFileSelected(){
                let data ={
                    file: this.adecImportFile.target.files[0],
                    printOption: this.adecImportPrintOption,
                    removeZeroCostRetail: this.ignoreZeroRetail,
                    importQuotePricing: this.importQuotePricing
                }
                OrderService.import(data)
                    .then((res) => {
                        let maxBundleId = 0;
                        let maxOrderLineNumber = 0;
                        if(this.orderLines.length > 0){
                            this.orderLines.forEach(line => {
                                if(line.LineNumber > maxOrderLineNumber){
                                    maxOrderLineNumber = line.LineNumber
                                }
                            })
                        }
                        this.bundles.forEach(bundle => {
                            if(bundle.OrderLineGroupId > maxBundleId){
                                maxBundleId = bundle.OrderLineGroupId
                            }
                        })
                        res.OrderLines.forEach(line => {
                            line.OrderLineGroupId += maxBundleId;
                            line.LineNumber += maxOrderLineNumber;
                            line.InitialDealerCost = line.DealerCost;
                            // line = this.$refs.CustomerOrderGrid[0].createObjectForRow(line)
                            line = this.roundLine(line)
                        })
                        res.Bundles.forEach(bundle => {
                            bundle.OrderLineGroupId += maxBundleId;
                            this.totalsSummary.push({...this.emptyTotal, id: bundle.OrderLineGroupId})
                            let bundleOrderLines = res.OrderLines.filter(line => {
                                return line.OrderLineGroupId === bundle.OrderLineGroupId;
                            })
                        })
                        this.$refs.CustomerOrderGrid[0].configureAdecOrderLines(res.OrderLines)
                        // this.orderLines = this.orderLines.concat([...res.OrderLines]);
                        this.bundles = this.bundles.concat([...res.Bundles]);
                        // this.reloadOrderLines();
                        this.updateOrderLineNumbers();
                        // this.setTotals();
                        this.toggleImportAdecOrderModal();
                    })
                    .catch((err) => {
                        this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message, type: 'error' });
                    })
            },
            roundLine(line){

                const customerKeys = ["CustomerExtended","CustomerCost"]
                const keys = ["Retail", "DealerCost", "InitialDealerCost", "Discount1","Discount2","DealerExtended","GPPercent"]

                keys.forEach(key => {
                    line[key] = this.roundToTwoDecimals(line[key])
                })
                customerKeys.forEach(key => {
                    line[key] = this.round(line[key])
                })
                return line;
            },
            updateOrderInfo(order){
                // this.formChanged()
                const answer = this.avoidRouteGuard || !this.formHasBeenChanged || this.committed || this.submitted || this.isReadOnly?
                true :
                window.confirm('Are you sure you would like to leave this page? You may have unsaved changes!');
                if(answer){
                    this.worksheetName = order.WorksheetName;
                }
                if(this.$route.name === 'CustomerOrderEdit' && answer){
                    this.$router.replace({ name: 'CustomerOrderEdit', params: { id: order.Id, cid: order.CustomerId } } );
                    this.openOrder();
                } else if(this.$route.name === 'CustomerOrder' && answer){
                    this.avoidRouteGuard = true;
                    this.$router.replace({ name: 'CustomerOrderEdit', params: { id: order.Id, cid: order.CustomerId } } );
                    this.openOrder();
                }
                this.formHasBeenChanged = false;

            },
            saveAndCreateNewOrder(){
                this.saveOrder()
                this.createNewOrder()
            },
            generateReportFinal(data){
							let formId = data.form.id;
							if ((this.isHSUS || this.isZAHN) && Number(this.businessVersion) < 2 && formId === 3) {
								formId = 92;
							}

							ReportService.generateWithOffset({ReportTypeId: formId, OrderId: this.$route.params.id}).then(res => {
									let fileURL = window.URL.createObjectURL(new Blob([res], {type: "application/pdf"}));
									let fileLink = document.createElement('a');
									fileLink.href = fileURL;
									fileLink.setAttribute('download', `${this.orderNumber}-${this.billingAddress.Name}-${data.form.DisplayName}.pdf`);
									document.body.appendChild(fileLink);
									fileLink.click();
							}).catch(err => {
									this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message, type: 'error' });
							})
            },
            generateReport(form){
                if(this.uncommitted && !this.isReadOnly){
                    this.saveOrder(this.generateReportFinal, {form: form});
                } else {
                    this.generateReportFinal({form: form})
                }
            },
						onGenerateForms(data) {
							if (this.uncommitted && !this.isReadOnly){
									this.saveOrder(this.onGenerateFormsFinal, data);
							} else {
									this.onGenerateFormsFinal(data)
							}
						},
            onGenerateFormsFinal(data) {
                this.$refs.formBuilderDialog.toggle();

								if ((this.isHSUS || this.isZAHN) && Number(this.businessVersion) < 2)  {
									// If businessVersion < 2, translate Worksheet to WorksheetV1
									for (let i = 0; i < data.reports.length; i++) {
										if (data.reports[i].ReportId === 3) {
											console.log('WorksheetV1');
											data.reports[i].ReportId = 92;
											break;
										}
									}
								}

                const dto = {
									OrderId: this.$route.params.id,
									TimezoneOffsetInMinutes: new Date().getTimezoneOffset(),
									Reports: data.reports,
                };

								const fileName = data.fileName;

                ReportService.formBuilder(dto).then(res => {
									let fileURL = window.URL.createObjectURL(new Blob([res], {type: "application/pdf"}));
                    let fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', `${fileName}`);
                    document.body.appendChild(fileLink);
                    fileLink.click();
									}).catch(err => {
										if (err.response?.data?.Message.includes('There is an issue with this order.')) {
											this.toggleCalculationErrorDialog();
										}
										else {
											const message = err.response.data.Message;
											const messageType = message.includes('WARNING') ? 'warning' : 'error';
											this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message, type: messageType });
										}
	                })
            },
						toggleCalculationErrorDialog() {
							this.$refs.calculationErrorDialog.toggle();
						},
						saveAndRefreshOrder() {
							if (this.uncommitted && !this.isReadOnly) {
								this.saveOrder(() => {
									this.refreshBrowser();
								});
							}
							else {
								this.refreshBrowser();
							}
						},
						refreshBrowser() {
							this.resetRouteGuardCheck();
							window.onbeforeunload = null;
							clearInterval(this.saveWarningInterval);
							this.$router.go();
						},
            cloneOrderFinal(){
                this.$v.currentCustomer.$touch();
                this.$v.ownerSalesRepId.$touch();
                if (this.$v.currentCustomer.$invalid || this.$v.ownerSalesRepId.$invalid){
                    // this.$store.dispatch('ADD_NOTIFICATION', { text: 'See Validation Errors', type: 'error' });
                    return;
                }
                let order = this.setOrderStructure()
                order.SalesRepId = this.currentUser.SalesRepId;
                order.WorksheetName = "";
								order.BusinessVersion = CURRENT_ORDER_BUSINESSVERSION;
								this.businessVersion = order.BusinessVersion;
                const isDuplicate = true;
                OrderService.clone(order, isDuplicate)
                    .then(async res => {
                        this.$store.dispatch('ADD_NOTIFICATION', { text: 'Order has been duplicated', type: 'success' });
                        this.avoidRouteGuard = true;
                        this.$router.replace({name: 'CustomerOrderEdit', params: {id: res.Id, cid: res.CustomerId}})

												if (Number(this.originalBusinessVersion) < 2) {
													this.$store.dispatch('ADD_NOTIFICATION', {
														text: "This order was duplicated from an older order version and pricing has been auto-refreshed to accommodate the new order version type." ,
														type: 'warning',
														noTimeout: true,
													});

													const refreshAll = true;
													this.getCurrentOrder(isDuplicate, ()=> this.refreshPricing(refreshAll))
												}
												else {
													this.getCurrentOrder(isDuplicate)
												}

												this.setTotals();
												this.OrderGridUpdateKey++;
											})
                    .catch(err => {
                        this.$store.dispatch('ADD_NOTIFICATION', { text: 'We were unable to duplicate your order at this time', type: 'error' });
                        console.log(err)
                    })
            },
            cloneOrder(){
								this.originalBusinessVersion = this.businessVersion;
                if (!this.isReadOnly && !this.submitted){
                    this.saveOrder(this.cloneOrderFinal)
                } else {
                    this.cloneOrderFinal()
                }

            },
            // cloneOrder(){
            //     if (!this.isReadOnly && !this.submitted) this.saveOrder()
            //     this.$v.currentCustomer.$touch();
            //     this.$v.ownerSalesRepId.$touch();
            //     if (this.$v.currentCustomer.$invalid || this.$v.ownerSalesRepId.$invalid){
            //         // this.$store.dispatch('ADD_NOTIFICATION', { text: 'See Validation Errors', type: 'error' });
            //         return;
            //     }
            //     let order = this.setOrderStructure()
            //     order.SalesRepId = this.currentUser.SalesRepId;
            //     order.WorksheetName = "";

            //     OrderService.clone(order)
            //         .then(res => {
            //             this.$store.dispatch('ADD_NOTIFICATION', { text: 'Order has been duplicated', type: 'success' });
            //             this.avoidRouteGuard = true;
            //             this.$router.replace({name: 'CustomerOrderEdit', params: {id: res.Id, cid: res.CustomerId}})
            //             this.getCurrentOrder()
            //             // this.orderId = res.Id;
            //         })
            //         .catch(err => {
            //             this.$store.dispatch('ADD_NOTIFICATION', { text: 'We were unable to duplicate your order at this time', type: 'error' });
            //             console.log(err)
            //         })
            // },
            createNewOrder(){
                if(this.$router.name !== 'CustomerOrder'){
                    this.avoidRouteGuard = true;
                    this.$router.replace({name: 'CustomerOrder'});
                }
                this.openNewOrder();
                this.toggleNewOrderModal();
            },
            openNewOrder(){
                this.rowVersion = null;
                this.worksheetName = '';
                this.installationDate =  null;
                this.expirationDate = null;
                this.generalNotes = '';
                this.confidentialNotes = '';
                this.creationDate = moment().format('L');
                this.creationTime = moment().format('LTS');
                this.revisionDate = moment().format('L');
                this.revisionTime = moment().format('LTS');
                // this.submittedDate = moment().format('L');
                // this.submittedTime = moment().format('LTS');
                // this.committedDate = moment().format('L');
                // this.committedTime = moment().format('LTS');
                this.paymentDueOn = null;
                this.bundles = [{OrderLineGroupName: 'Individual Line Items', Id: null, OrderLineGroupId: 0, PrintOptionId: 4, Quantity: 1}];
                this.CustomFreight = false;
                this.CustomDownPayment = false;
                this.EquipmentRepCode = null;
                this.AdditionalRepCode = null;
                this.AdditionalRep2Code = null;
                this.EquipmentRepName = null;
                this.AdditionalRepName = null;
                this.AdditionalRep2Name = null;
                this.isReadOnly = false;
                this.orderNumber = ''
                this.orderStatusId = 1;
                this.transferredSalesRepId = null;
								this.businessVersion = CURRENT_ORDER_BUSINESSVERSION;
								this.orderType = null;
                this.getUserSalesTaxInfo();
                this.openOrder();

            },
            submitToOrderLink(){
                // Check if OrderType is set for HSUS or HSCA dealers
                if ((this.isHSUS || this.isHSCA) && !this.orderType) {
                    this.$store.dispatch('ADD_NOTIFICATION', { text: 'Order Type Must Be Set To Submit an Order', type: 'warning' });
                    return;
                }

                OrderService.submitOrderLink([this.$route.params.id])
                    .then((result) => {
                        this.orderLinkUrl = result.HSUSFollowUpLink;

                        if (this.orderLinkUrl) {
                            this.$refs.orderLinkNextStepsDialog.toggle();
                        }

                        this.$store.dispatch('ADD_NOTIFICATION', { text: 'Your order has been submitted to OrderLink.', type: 'success' });
                        this.orderStatusId = 3;
                        this.submittedDate = moment().format('L');
                        this.submittedTime = moment().format('LTS');

                        // Find the Worksheet report
												const worksheet = {
													id: this.isHSUS ? 3 : this.isZAHN ? 122 : 54,
													DisplayName: 'Worksheet',
												}

                        // Find the Equipment Installation List report
												const equipmentInstallationList = (this.isHSUS || this.isZAHN) ? {
													id: this.isHSUS ? 24 : 123,
													DisplayName: 'Equipment Installation List',
												} : null;

                        // Generate the reports
                        if (worksheet) {
                            this.generateReport(worksheet);
                        }

                        if (equipmentInstallationList) {
                            this.generateReport(equipmentInstallationList);
                        }
                    })
                    .catch((err) => {
                        const errorMessage = err.response?.data?.Message || 'Unable to submit order at this time to OrderLink.';
                        this.$store.dispatch('ADD_NOTIFICATION', { text: errorMessage, type: 'error' });
                    })
            },
            async saveAndCommitOrder(){
                this.$v.installationDate.$touch();
                this.$v.currentCustomer.$touch();
                this.$v.ownerSalesRepId.$touch();
                let isValid = true;
                if (this.$v.currentCustomer.$invalid){
                    this.$store.dispatch('ADD_NOTIFICATION', { text: 'Please select a customer', type: 'error' });
                    isValid = false;
                }
                if (this.$v.installationDate.$invalid){
                    this.$store.dispatch('ADD_NOTIFICATION', { text: 'Please select an installation date', type: 'error' });
                    isValid = false;
                }
                if (this.$v.ownerSalesRepId.$invalid){
                    this.$store.dispatch('ADD_NOTIFICATION', { text: 'Please select an order owner', type: 'error' });
                    isValid = false;
                }
                // Check if OrderType is set for HSUS or HSCA dealers
                if ((this.isHSUS || this.isHSCA) && !this.orderType && this.orderTypeOptions.length > 0){
                    this.$store.dispatch('ADD_NOTIFICATION', { text: 'Order Type Must Be Set To Submit an Order', type: 'warning' });
                    isValid = false;
                }
                if(!isValid){
                    return;
                }
                let order = this.setOrderStructure()
                OrderService.update(order)
                    .then((res) => {
                        if (res?.RowVersion) this.rowVersion = res.RowVersion;
                        // this.$store.dispatch('ADD_NOTIFICATION', { text: 'Order has been saved', type: 'success' });
                        this.avoidRouteGuard = true;
                        this.formHasBeenChanged = false;
                        this.committedDate = moment().format('L');
                        this.committedTime = moment().format('LTS');
                        this.commitOrder();
                    })
                    .catch(() => {
                        this.$store.dispatch('ADD_NOTIFICATION', { text: 'We were unable to commit your order at this time', type: 'error' });
                    })
                    .finally(() => {
                        this.toggleCommitModal()
                    })
                // await this.saveOrder();

            },

            commitOrder(){
                OrderService.commit([this.$route.params.id])
                    .then((res) => {
                        if (res?.length > 0 && res[0]?.RowVersion) this.rowVersion = res[0].RowVersion;
                        this.$store.dispatch('ADD_NOTIFICATION', { text: 'Your order has been committed', type: 'success' });

                        this.$store.dispatch('UPDATE_ORDER_INFO', {number: this.$route.params.id, readOnly: true});
                        this.orderStatusId = 2;
                        // orderStatus();
                        // this.isReadOnly = true;
                    })
                    .catch(() => {
                        this.$store.dispatch('ADD_NOTIFICATION', { text: 'Unable to commit order at this time', type: 'error' });
                    })
            },
            updateCustomerInfo(){
                this.formChanged()
                // if(this.$route.params.id){
                    // this.avoidRouteGuard = true;
                    this.$router.replace({ params: {cid: this.currentCustomer.Id}});
                this.getCurrentCustomerUnsavedOrder(this.currentCustomer.Id)
                // this.updateBillingShippingInfo()
            },
            bundleWithSubtotalIncluded(){
                let newBundles = []
                this.bundles.forEach(bundle => {
                    let index = this.totalsSummary.map(total => total.id).indexOf(bundle.OrderLineGroupId);
                    newBundles.push({
                        ...bundle,
                        Subtotal: this.totalsSummary[index].subtotal
                    })
                })
                return newBundles;
            },
            setOrderStructure(){
                let eqRep = this.getEquipmentRep();
                let addRep = this.getAdditionalRep();
                let addRep2 = this.getAdditionalRep2();
                let res = {
                    Id: this.$route.params.id || null,
                    JdeNumber: this.currentCustomer.JdeNum,
                    CustomerName: this.currentCustomer.Name,
                    CustomerId: this.currentCustomer.Id,
                    OrderStatusId: this.orderStatusId,
                    DealerId: this.currentUser.DealerId,
                    Status: null,
                    Bundles: this.bundleWithSubtotalIncluded(),
                    CreatedOn: moment(this.creationDate).format('L'),
                    RevisedOn: moment(this.revisionDate).format('L'),
                    CommittedOn: moment(this.committedDate).format('L'),
                    SubmittedOn: moment(this.submittedDate).format('L'),
                    InstalledOn: moment(this.installationDate).format('L'),
                    ExpiresOn: moment(this.expirationDate).format('L'),
                    BillingInfo: this.billingAddress,
                    ShippingInfo: this.shippingAddress,
                    InstallationInfo: this.installAddress,
                    SalesRepId: this.ownerSalesRepId,
                    EquipmentRepCode: this.EquipmentRepCode,
                    EquipmentRepTitle: eqRep.Title,
                    EquipmentRepName: eqRep.Name,
                    EquipmentRepFirstName: eqRep.FirstName,
                    EquipmentRepLastName: eqRep.LastName,
                    EquipmentRepEmailAddress: eqRep.Email,
                    EquipmentRepPhoneNumber: eqRep.Phone,
                    EquipmentRepId: eqRep.Id,
                    AdditionalRepCode: this.AdditionalRepCode,
                    AdditionalRepTitle: addRep.Title,
                    AdditionalRepName: addRep.Name,
                    AdditionalRepFirstName: addRep.FirstName,
                    AdditionalRepLastName: addRep.LastName,
                    AdditionalRepEmailAddress: addRep.Email,
                    AdditionalRepPhoneNumber: addRep.Phone,
                    AdditionalRepId: addRep.Id,
                    AdditionalRep2Code: this.AdditionalRep2Code,
                    AdditionalRep2Title: addRep2.Title,
                    AdditionalRep2Name: addRep2.Name,
                    AdditionalRep2FirstName: addRep2.FirstName,
                    AdditionalRep2LastName: addRep2.LastName,
                    AdditionalRep2EmailAddress: addRep2.Email,
                    AdditionalRep2PhoneNumber: addRep2.Phone,
                    AdditionalRep2Id: addRep2.Id,
                    TransferredFromRepId: null,
                    PaymentDueOn: moment(this.paymentDueOn).format('L'),
                    GeneralNotes: this.generalNotes,
                    ConfidentialNotes: this.confidentialNotes,
                    OrderLines: this.orderLines,
                    OrderTypeId: this.orderType,
                    SalesTax: this.totals.salesTaxAmount,
                    SalesTaxRate: this.totals.salesTax,
                    Freight: this.totals.freight,
                    FreightPercentage: this.CustomFreight ? null : this.defaultFreightPercent,
                    DownPaymentPercentage: this.CustomDownPayment ? null : this.defaultDownPaymentPercent,
                    DownPayment: this.totals.downPayment,
                    SubTotal: this.totals.subtotal,
                    Total: this.totals.total,
                    BalanceDue: this.totals.balanceDue,
                    Discount: this.totals.discount,
                    DealerCost: this.totals.dealerCost,
                    DiscountPercentage: this.totals.discountPercent,
                    Profit: this.totals.profit,
                    CustomDownPayment: this.CustomDownPayment,
                    CustomFreight: this.CustomFreight,
                    OrderSalesSettings: this.OrderSalesSettings,
                    WorksheetName: this.worksheetName,
										BusinessVersion: this.businessVersion,
                    RowVersion: this.rowVersion,
                }
                return res;
            },
            async saveOrder(callback = null, callbackParams = {}){
                try {
                    if(typeof(callback) !== 'function'){
                        callback = null;
                    }

                    // Prevent saves on read-only orders
                    if (this.isReadOnly) {
                        console.log('Order is read-only, skipping save request');
                        if (callback) {
                            callback(callbackParams);
                        }
                        return;
                    }

                    // Prevent multiple simultaneous saves
                    if (this.isSaving) {
                        console.log('Save already in progress, skipping duplicate save request');
                        return;
                    }
                    this.isSaving = true;

                    //this.setTotalsForSave();

                    this.$v.currentCustomer.$touch();
                    this.$v.ownerSalesRepId.$touch();
                    this.$v.generalNotes.$touch();
                    this.$v.confidentialNotes.$touch();
                    // if (this.$v.currentCustomer.$invalid || this.$v.ownerSalesRepId.$invalid){
                    //     this.$store.dispatch('ADD_NOTIFICATION', { text: 'See Validation Errors', type: 'error' });
                    //     return;
                    // }
                    let isValid = true;
                    if (this.$v.currentCustomer.$invalid){
                        this.$store.dispatch('ADD_NOTIFICATION', { text: 'Please select a customer', type: 'error' });
                        isValid = false;
                    }
                    if (this.$v.ownerSalesRepId.$invalid){
                        this.$store.dispatch('ADD_NOTIFICATION', { text: 'Please select an order owner', type: 'error' });
                        isValid = false;
                    }
                    if (this.$v.confidentialNotes.$invalid || this.$v.generalNotes.$invalid){
                        this.$store.dispatch('ADD_NOTIFICATION', { text: 'Notes may only have 1000 characters', type: 'error' });
                        isValid = false;
                    }
                    if(!isValid){
                        this.isSaving = false;
                        return;
                    }

                    this.updateOrderLineNumbers();

                    // Wait for Vue's reactivity system to complete updates
                    await this.$nextTick();

                    // Wait for any pending grid operations to complete
                    await this.waitForGridOperations();

                    let order = this.setOrderStructure()

                    // Ensure MfgId gets cleared if manufacturer unselected
                    order.OrderLines.forEach(x => {
                        if (x.MfgCode == '') {
                            x.MfgId = null
                        }
                    })

                    if(order.Id === null){
                        await this.saveNewOrder(order, callback, callbackParams)
                    } else {
                        await this.updateOrder(order, callback, callbackParams)
                    }

                    this.formHasBeenChanged = false;
                }
                catch (e) {
                    const message = 'General error saving order: ' + e.message;
                    this.$store.dispatch('ADD_NOTIFICATION', { text: message, type: 'error' });
                    console.log(message, e)
                }
                finally {
                    this.isSaving = false;
                }
            },
            async waitForGridOperations() {
                // Wait for any pending grid operations to complete
                // This replaces the 750ms setTimeout with a more precise approach

                // Check if we have grid references that might be updating
                const gridRefs = ['CustomerOrderGrid', 'orderGrid'];

                for (const refName of gridRefs) {
                    const gridRef = this.$refs[refName];
                    if (gridRef && gridRef.instance) {
                        // If the grid has pending operations, wait for them
                        if (typeof gridRef.instance.saveEditData === 'function') {
                            try {
                                await gridRef.instance.saveEditData();
                            } catch (e) {
                                // Grid might not have pending edits, continue
                                console.log('Grid saveEditData completed or no pending edits');
                            }
                        }
                    }
                }

                // Additional small delay to ensure all DOM updates are complete
                // This is much smaller than the original 750ms but ensures stability
                await new Promise(resolve => setTimeout(resolve, 50));
            },
            async saveNewOrder(order, callback = null, callbackParams = {}){
                try {
                    const res = await OrderService.create(order);
                    if (res?.RowVersion) this.rowVersion = res.RowVersion;
                    this.$store.dispatch('ADD_NOTIFICATION', { text: 'Order has been saved', type: 'success' });
                    this.avoidRouteGuard = true;
                    this.orderNumber = res.OrderNumber;

                    this.$router.replace({name: 'CustomerOrderEdit', params: {id: res.Id, cid: res.CustomerId}})
                    this.$store.dispatch('UPDATE_ORDER_INFO', {number: res.OrderNumber, readOnly: false});
                    clearInterval(this.saveWarningInterval);
                    this.saveWarning()
                    // this.orderId = res.Id;
                    if(callback){
                        callback(callbackParams);
                    }

                    this.$store.dispatch('UPDATE_FAVORITES');
                } catch (err) {
                    this.$store.dispatch('ADD_NOTIFICATION', { text: 'We were unable to save your order at this time', type: 'error' });
                    console.log(err)
                    throw err; // Re-throw to allow calling code to handle
                }
            },
            async updateOrder(order, callback = null, callbackParams = {}){
                try {
                    const res = await OrderService.update(order);
                    if (res?.RowVersion) this.rowVersion = res.RowVersion;

                    this.$store.dispatch('ADD_NOTIFICATION', { text: 'Order has been saved', type: 'success' });
                    this.avoidRouteGuard = true;
                    this.formHasBeenChanged = false;
                    clearInterval(this.saveWarningInterval);
                    this.saveWarning()
                    if(callback){
                        callback(callbackParams);
                    }

                    this.$store.dispatch('UPDATE_FAVORITES');
                } catch (err) {
                    if (err.response?.status === 409 || err.response?.data?.includes?.('CONCURRENCY_CONFLICT') || err.message?.includes?.('CONCURRENCY_CONFLICT')) {
                        // Concurrency conflict - show modal popup
                        this.showConcurrencyConflictModal();
                    } else {
                        this.$store.dispatch('ADD_NOTIFICATION', { text: 'We were unable to save your order at this time', type: 'error' });
                    }
                    throw err; // Re-throw to allow calling code to handle
                }
            },
            updateTotalsValues(tot, groupId){
                // this.formChanged('updateTotalsValues')
                let totalsIndex = this.bundles.map(group => group.OrderLineGroupId).indexOf(groupId)
                this.totalsSummary[totalsIndex] = this.copy(tot)
                this.setTotals()
            },
            updateOrderLines(lineNumber, bundleId){
                // this.updateLineIds()
                let orderLineIndex = this.orderLines.map(line => line.LineNumber).indexOf(lineNumber);
                let bundleIndex = this.bundles.map(group => group.OrderLineGroupId).indexOf(bundleId);
                this.orderLines[orderLineIndex].OrderLineGroupName = this.bundles[bundleIndex].OrderLineGroupName;
                this.updateOrderLineNumbers();
                this.reloadOrderLines();
            },
            updateOrderLineNumbers(){
                let number = 0;
                let reorderedLines = []

                this.bundles.forEach(bundle => {
                    this.orderLines.forEach(line => {
                        if(line.OrderLineGroupId === bundle.OrderLineGroupId){
                            line.LineNumber = number;
                            reorderedLines.push(line)
                            number++;
                        }
                    })
                })

                this.orderLines = reorderedLines;
            },
            pasteOrderLines(orderLinesAdded, rowIndex){
                orderLinesAdded.forEach(line => {
                    line.OrderLineId = null
                })
                this.orderLines.splice(rowIndex+1, 0, ...orderLinesAdded)
                this.updateOrderLineNumbers()

                //api
            },
            reloadOrderLines(){
                this.OrderGridUpdateKey += 1;
            },
            toggleDeleteModal(){
                this.$refs.deleteOrderModal.toggle();
            },
            toggleCommitModal(){
                this.$refs.commitOrderModal.toggle();
            },
            openTransferModal(){
                this.selectedTransferRepId = null;
                this.$refs.transferOrderModal.toggle();
            },
            confirmTransfer(){
                if (!this.selectedTransferRepId) return;
                OrderService.transferOwner(this.$route.params.id, this.selectedTransferRepId)
                    .then(() => {
                        this.$refs.transferOrderModal.toggle();
                        this.$store.dispatch('ADD_NOTIFICATION', { text: 'Order transferred successfully.', type: 'success' });
                        this.$router.push({ name: 'OrderSearch' });
                    })
                    .catch(err => {
                        this.$store.dispatch('ADD_NOTIFICATION', { text: err.response?.data || 'Error transferring order.', type: 'error' });
                    });
            },
            toggleNewOrderModal(){
                this.$refs.newOrderModal.toggle();
            },
            importSmartSalesFileSelected() {
                var [file] = document.getElementById('smartSalesImportFile').files;
                var reader = new FileReader();
                var self = this;

                reader.addEventListener("load", function() {
                    self.loadSavedOrder(reader.result)
                }, false);

                if (file) {
                    reader.readAsText(file);
                }
            },
            loadSavedOrder (orderObjectText) {
                try {
                    const order = this.getOrderObject(orderObjectText);
                    if (!order) {
                        this.$store.dispatch('ADD_NOTIFICATION', { text: 'Error loading order data from file.', type: 'error' });
                        return
                    }

                    if (typeof(order.OrderLines) !== 'object') {
                        this.$store.dispatch('ADD_NOTIFICATION', { text: 'Data in saved file is not order data.', type: 'error' });
                        return
                    }

                    if (this.isCreateNewOrder) {
                        order.Id = null;
                        order.OrderStatusId = 1;
                        order.SubmittedOn = null;
                        order.CommittedOn = null;

                        for (let index = 0; index < order.Bundles.length; ++index) {
                            const bundle = order.Bundles[index];

                            bundle.Id = null;
                            bundle.OrderLineGroupId = index;

                            for (const line of order.OrderLines) {
                                line.OrderLineId = null;
                                if (line.OrderLineGroupName === bundle.OrderLineGroupName) {
                                    line.OrderLineGroupId = bundle.OrderLineGroupId;
                                }
                            }
                        }

                        this.newOrderHasBeenRequested();
                        this.setupOrder(order);
                        this.afterOrderLoadTasks();
                    }
                    else if (this.isAddToExistingOrder) {
                        let sequence = this.bundles.reduce((x,y) => Math.max(x, y.OrderLineGroupId), 0) + 1;

                        for (const bundle of order.Bundles) {
                            bundle.OrderLineGroupId = sequence;
                            bundle.Id = null;
                            bundle.workingName = bundle.OrderLineGroupName;

                            ++sequence;

                            if (this.doesBundleExist(bundle.OrderLineGroupName)) {
                                const bundleNewName = this.createNewBundleName(bundle.OrderLineGroupName)
                                bundle.OrderLineGroupName = bundleNewName;
                            }

                            for (const line of order.OrderLines) {
                                if (line.OrderLineGroupName === bundle.workingName) {
                                    line.OrderLineGroupId = bundle.OrderLineGroupId;
                                    line.OrderLineGroupName = bundle.OrderLineGroupName;
                                }
                            }

                            this.bundles.push(bundle);
                        }

                        for (const line of order.OrderLines) {
                            line.OrderLineId = null;
                        }

                        this.orderLines = this.orderLines.concat(this.sortOrderLinesByLineNumber(order.OrderLines));
                    }

                    for (const bundle of this.bundles) {
                        bundle.Id = null;
                    }

                    this.resetBundleTotals();

                    this.$store.dispatch('ADD_NOTIFICATION', { text: 'Order data loaded successfully.', type: 'success' });
                    this.$refs.importSmartSalesOrderModal.toggle();
                }
                catch(e) {
                    console.error('Error processing loaded order data: ', e);
                    this.$store.dispatch('ADD_NOTIFICATION', { text: 'Error processing loaded order data. ' + e, type: 'error' });
                }
            },
            doesBundleExist(bundleName) {
                const exists = this.bundles.findIndex(x => x.OrderLineGroupName === bundleName) !== -1;
                return exists;
            },
            createNewBundleName(originalName) {
                let suffix = 1;
                while (true) {
                    const checkName = originalName + `(${suffix})`
                    if (!this.doesBundleExist(checkName)) {
                        return checkName;
                    }
                    ++suffix;
                }
            },
            getOrderObject(jsonStr) {
                try {
                    const result = JSON.parse(jsonStr);
                    return result;
                } catch (e) {
                    console.error('Error parsing saved order file: ', e)
                    this.$store.dispatch('ADD_NOTIFICATION', { text: 'Could not read order data from file. ' + e, type: 'error' });
                    return false;
                }
            },
            cleanupOrder(order) {
                const data = { ...order }

                data.Id = null;

                for(const bundle of data.Bundles) {
                    bundle.OrderId = null;
                    bundle.Id = null;
                }

                for (const line of data.OrderLines) {
                    line.OrderId = null;
                    line.OrderLineId = null;
                }

                return data;
            },
            saveOrderLocally() {
                //const order = this.cleanupOrder(this.setOrderStructure())
                const initialOrder = this.setOrderStructure();
                const order = this.cleanupOrder(initialOrder);
                const data = JSON.stringify(order, null, 3);

                const blob = new Blob([data], {type: 'text/plain'})
                const e = document.createEvent('MouseEvents'),
                a = document.createElement('a');

                a.download = (this.orderNumber || (new Date()).toISOString()) + '.json';

                a.href = window.URL.createObjectURL(blob);
                a.dataset.downloadurl = ['text/json', a.download, a.href].join(':');
                e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
                a.dispatchEvent(e);

                this.$store.dispatch('ADD_NOTIFICATION', { text: 'Order data downloaded.', type: 'success' });
            },
            newOrderHasBeenRequested(){
                if(this.avoidRouteGuard || !this.formHasBeenChanged){
                    if(this.$router.name !== 'CustomerOrder'){
                        this.avoidRouteGuard = true;
                        this.$router.replace({name: 'CustomerOrder'});
                    }
                    this.openNewOrder();
                } else {
                    this.toggleNewOrderModal()
                }
            },
            deleteOrder(){
                if(!this.uncommitted){
                    this.$store.dispatch('ADD_NOTIFICATION', { text: `Orders that are ${this.orderStatus} may not be deleted.` , type: 'error' });
                    return;
                }
                OrderService.delete({id: this.$route.params.id})
                    .then((res) => {
                        this.$store.dispatch('ADD_NOTIFICATION', { text: "Order has been deleted" , type: 'success' });
                        this.$store.dispatch('UPDATE_FAVORITES');
                        this.$router.replace({ name: 'CustomerOrder'})
                        this.openNewOrder()
                    })
                    .catch((err) => {
                        this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message , type: 'error' });
                    })
                this.toggleDeleteModal();

            },
            toggleUncommitModal(){
                this.$refs.uncommitOrderModal.toggle();
            },
            showConcurrencyConflictModal(){
                this.$refs.concurrencyConflictModal.toggle();
            },
            closeConcurrencyModal(){
                this.$refs.concurrencyConflictModal.toggle();
                // Optionally reload the page to get the latest order data
                // this.$router.go(0);
            },
            // toggleRouteGuardModal(){
            //     this.$refs.routeGuardModal.toggle();
            // },
            uncommitOrder(){
                if(!this.committed){
                    this.$store.dispatch('ADD_NOTIFICATION', { text: `Orders that are ${this.orderStatus} may not be uncommitted.` , type: 'error' });
                    return;
                }

                OrderService.uncommit([this.$route.params.id])
                    .then((res) => {
                        if (res?.RowVersion) this.rowVersion = res.RowVersion;
                        this.orderStatusId = 1;
                        this.$store.dispatch('UPDATE_ORDER_INFO', {number: this.$route.params.id, readOnly: false});
                        this.$store.dispatch('ADD_NOTIFICATION', { text: "Order has been uncommitted" , type: 'success' });
                        this.saveOrder()
                    })
                    .catch((err) => {
                        this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message , type: 'error' });
                    })
                this.toggleUncommitModal();
            },
            editBundle(bundle){

                let bundleIndex = this.bundles.map(b => b.OrderLineGroupId).indexOf(bundle.OrderLineGroupId)
                this.bundles[bundleIndex] = bundle;
                if(bundle.OrderLineGroupId !== bundle.Sequence){
                    this.repositionBundles(bundle.OrderLineGroupId, bundle.Sequence);
                }
                this.bundles[bundleIndex].Quantity = bundle.Quantity
                this.orderLines.forEach(line => {
                    if(line.OrderLineGroupId === bundle.OrderLineGroupId){
                        line.OrderLineGroupName = bundle.OrderLineGroupName;
                        line.PrintOptionId = bundle.PrintOptionId;
                    }
                })
                this.reloadOrderLines()
            },
            createNewBundle(title, printOptionId, sequence, quantity ){
                let newId = 0;
                this.bundles.forEach(group => {
                    if(group.OrderLineGroupId >= newId){
                        newId = group.OrderLineGroupId + 1;
                    }
                })
                this.bundles.push({OrderLineGroupName: title, OrderLineGroupId: newId, Id: null, PrintOptionId: printOptionId, Quantity: quantity})
                this.orderLines.forEach(line => {
                    if(line.OrderLineGroupId === -1) line.OrderLineGroupId = newId
                })
                this.totalsSummary.push({...this.emptyTotal, id: newId})
                this.repositionBundles(newId, sequence);
                // this.reloadOrderLines()
            },
            deleteBundle(groupId){
                let groupIndex = this.bundles.map(group => group.OrderLineGroupId).indexOf(groupId)
                let totalsIndex = this.totalsSummary.map(totals => totals.id).indexOf(groupId)
                this.bundles.splice(groupIndex, 1)
                this.totalsSummary.splice(totalsIndex, 1)
                let linesToDelete = [];
                this.orderLines.forEach((line, index) => {
                    if(line.OrderLineGroupId === groupId){
                        linesToDelete.push(line.LineNumber)
                        // this.orderLines.splice(index, 1)
                    }
                })
                linesToDelete.sort(function(a,b){ return b - a; })
                for (var i = linesToDelete.length -1; i >= 0; i--){
                    let index = this.orderLines.map(line => line.LineNumber).indexOf(linesToDelete[i])
                    this.orderLines.splice(index,1);
                }
                this.setTotals()
            },
            deleteBundleAndKeepOrderLines(groupId){
                let groupIndex = this.bundles.map(group => group.OrderLineGroupId).indexOf(groupId)
                let totalsIndex = this.totalsSummary.map(totals => totals.id).indexOf(groupId)
                this.bundles.splice(groupIndex, 1)
                this.totalsSummary.splice(totalsIndex, 1)
                this.orderLines.forEach((line, index) => {
                    if(line.OrderLineGroupId === groupId){
                        line.OrderLineGroupId = 0;
                    }
                })
                this.OrderGridUpdateKey++;
            },
            freightChanged(isPercent){
                this.CustomFreight = !isPercent;
                this.setTotals();
            },
            storeFreightPercent(percent){
                this.defaultFreightPercent = Number(percent);
                this.totals.isFreightPercent = true;
                this.CustomFreight = false;
                this.setTotals();
            },
            downPaymentChanged(isPercent){
                this.CustomDownPayment = !isPercent;
                this.setTotals();
            },
            setTotalsForSave() {
                // Double check that the summary values are all added up.
                for (const summary of this.totalsSummary) {
                    const orderLines = this.orderLines.filter(x => x.OrderLineGroupId === summary.id);

                    summary.subtotal = 0;
                    summary.retail = 0;
                    summary.dealerCost = 0;

                    for (const orderLine of orderLines) {
                        summary.subtotal += orderLine.CustomerExtended;
                        summary.retail += orderLine.Retail * orderLine.Quantity;
                        summary.dealerCost += orderLine.DealerExtended;
                    }
                }

                this.setTotals();
            },
            setTotals(){
							// TODO: if order is committed, do not calculate
							if (this.committed || this.readOnly) {
								console.log('Order is committed or read-only, skipping totals calculation')
								return;
							}

                // const keys = Object.keys(this.totals)
                this.totals.subtotal = 0;
                this.totals.retail = 0;
                this.totals.dealerCost = 0;
                this.totalsSummary.forEach(total => {
                    this.totals.subtotal += total.subtotal;
                    this.totals.retail += total.retail;
                    this.totals.dealerCost += total.dealerCost;
                })
                // if(this.totals.subtotal === 0){
                //     console.log('a')
                //     this.totals.freight = 0;
                // } else

								//console.log('Recalculating freight!!!!!!!!')
                if(this.totals.isFreightPercent && !this.CustomFreight){
                    this.totals.freight = this.roundToTwoDecimals((this.totals.subtotal * Number(this.defaultFreightPercent)/100));
                } else if(this.totals.isFreightPercent && this.CustomFreight){
                    this.totals.freight = this.roundToTwoDecimals(this.totals.freight);
                } else if(!this.totals.isFreightPercent && this.CustomFreight){
                    this.totals.freight = this.roundToTwoDecimals(this.totals.freight);
                } else if (!this.defaultFreightPercent) {
                    this.totals.freight = this.roundToTwoDecimals(this.defaultFreightAmount);
                }

								this.totals.salesTaxAmount          = this.calculateTax()
                this.totals.total                   = this.totals.subtotal + this.totals.freight + this.totals.salesTaxAmount;

								if (this.isHSUS || this.isZAHN) {
									//console.log('Calculating down payment by HSUS rules ', this.defaultDownPaymentPercent)
									this.totals.downPayment = this.CustomDownPayment ? this.roundToTwoDecimals(this.totals.downPayment) : this.roundToTwoDecimals(this.totals.total *(this.defaultDownPaymentPercent/100));
								}
								else {
									//console.log('Calculating down payment by HSCA rules ', this.defaultDownPaymentPercent)
									this.totals.downPayment = this.CustomDownPayment ? this.roundToTwoDecimals(this.totals.downPayment) : this.roundToTwoDecimals(this.totals.subtotal *(this.defaultDownPaymentPercent/100));
								}

								this.totals.balanceDue              = this.totals.total - this.totals.downPayment;
                this.totals.discountPercent         = this.roundToTwoDecimals(((this.totals.retail - this.totals.subtotal) / this.totals.retail) * 100)
                this.totals.discount                = this.totals.retail - this.totals.subtotal;
                this.totals.profit                  = this.totals.retail - this.totals.dealerCost - this.totals.discount;
                this.totals.actualGP                = this.roundToThreeDecimals(((this.totals.subtotal - this.totals.dealerCost) / this.totals.subtotal) * 100);

								if ((this.isHSUS || this.isZAHN) && this.businessVersion >= 2) {
									this.totals.commissionableGP = +(((this.totals.subtotal - (this.totals.dealerCost * 1.02)) / this.totals.subtotal) * 100).toFixed(2);
								}

                this.setTotalsTwoDecimal()
            },
            calculateTax() {
                const subtotalWithFreight = this.OrderSalesSettings.TaxFreight ? this.totals.subtotal + this.totals.freight : this.totals.subtotal;
                return this.roundToTwoDecimals((((subtotalWithFreight) * this.totals.salesTax)/100));
            },
            roundToTwoDecimals(data){
                if(Number(data) === 'NaN') return;
                // console.log('data', data);                   //output => 2379.3
                // console.log(data*100);                       //output => 237930.00000000003
                // console.log(Math.ceil(data * 100)/100);      //output => 2379.31
                //in the below return I added the "toFixed(6) because at times js will do some funky things with calculations.. the example above was a real example."
                return Math.ceil((data * 100).toFixed(6)) / 100;
            },
            roundToThreeDecimals(data){
                if(Number(data) === 'NaN') return;
                return Number(Number(data).toFixed(3));
            },
            round(data){
                if(Number(data) === 'NaN') return;
                return this.OrderSalesSettings.RoundToNearestDollar ? Math.ceil(data) : this.roundToTwoDecimals(data);
            },
            setTotalsTwoDecimal(){
                const keys = Object.keys(this.totals)
                keys.forEach(key => {
                    if(key === 'isFreightPercent') return;
                    if(this.totals[key] === null) return;
                    if(key === 'salesTax') {
                        this.totals[key] = Number(this.totals[key].toFixed(4));
                    } else {
                        this.totals[key] = Number(this.totals[key].toFixed(2));
                    }
                    // this.totals[key] = this.totalShouldBeRoundedToNearestDollar(key) ? Number(this.totals[key].toFixed(0)) : Number(this.totals[key].toFixed(2));
                })
            },
            totalShouldBeRoundedToNearestDollar(key){
                return this.OrderSalesSettings.RoundToNearestDollar && key === 'actualGP' && key !== 'discountPercent'
            },
            updateShippingInfo(shippingId){
                if(shippingId){
                    let index = this.currentCustomer.Addresses.map(address => address.AddressId).indexOf(shippingId);
                    this.shippingAddress = {
                        ...this.emptyAddress,
                        ...this.currentCustomer.Addresses[index],
                        // LastUsedCustomerAddressId: this.currentCustomer.Addresses[index].AddressId
                        //maybe add contact info here
                    }
                }
                else{
                    this.shippingAddress = {
                        ...this.emptyAddress,
                        // LastUsedCustomerAddressId: null
                        //maybe add contact info here
                    }
                }

            },
            updateBillingShippingInfo(){
                let customerContact = {};
                if(this.currentCustomer.CustomerContact){
                    customerContact = {
                        PhoneNumber: this.currentCustomer.CustomerContact.PhoneNumber,
                        Contact: this.currentCustomer.CustomerContact.FirstName + " " + this.currentCustomer.CustomerContact.LastName,
                        Name: this.currentCustomer.Name
                    };
                } else {
                    customerContact = { PhoneNumber: '', Contact: '', Name: ''};
                }

                let address = {...this.emptyAddress}

                if (this.currentCustomer.Address) {
                    address = {...this.currentCustomer.Address}
                }
                else if(this.currentCustomer.Addresses[0]){
                    address = {...this.currentCustomer.Addresses[0]}
                }
                this.billingAddress = {
                    ...address,
                    ...customerContact,
                    Name: this.currentCustomer.Name,
                    // CountryId: 1, //currently set to USA, will need to change when saved customers are from different countries

                }
                this.shippingAddress = {...this.billingAddress}
                this.installAddress = {...this.billingAddress}

                let mimicEventDataBilling = {
                    target: {
                        value: this.billingAddress.CountryId || 1,
                        mimic: true
                    }
                }
                let mimicEventDataShipping = {
                    target: {
                        value: this.shippingAddress.CountryId || 1,
                        mimic: true
                    }
                }
                let mimicEventDataInstall = {
                    target: {
                        value: this.installAddress.CountryId || 1,
                        mimic: true
                    }
                }

                this.getStatesForCountryBilling(mimicEventDataBilling);
                this.getStatesForCountryShipping(mimicEventDataShipping);
                this.getStatesForCountryInstall(mimicEventDataInstall);
            },
            getUserSalesTaxInfo(){
                UserService.salesTax(this.currentUser.SalesRepId)
                    .then(res => {
                        this.OrderSalesSettings = res;
                        this.totals.isFreightPercent = res.IsDefaultFreightPercent;
                        this.defaultFreightPercent = res.IsDefaultFreightPercent ? res.DefaultFreight : null;
                        this.defaultFreightAmount = res.IsDefaultFreightPercent ? null : res.DefaultFreight;
                        this.defaultGP = res.GPPercent;
                        this.defaultDownPaymentPercent = res.DefaultDeposit === null ? 10 : res.DefaultDeposit;
                        if(!this.$route.params.id && !this.$route.params.cid || this.totals.salesTax === null || this.totals.salesTax === undefined){
                            this.totals.salesTax = res.SalesTax ;
                        }
                    })
                    .catch(err => {
                        console.error(err)
                    })

            },
            copy(obj){
                return JSON.parse(JSON.stringify(obj))
            },
            resetBundleTotals(){
                if(this.orderLines.length <= 0) return;
                this.totalsSummary = []
                this.bundles.forEach(bundle => {
                    this.totalsSummary.push({...this.emptyTotal, id: bundle.OrderLineGroupId})
                })
                // this.OrderGridUpdateKey++;
            },
            getCurrentCustomer(id){
                if(!id) {
                    this.getCustomerByJde();
                    return;
                }
                CustomerService.get({id: id})
                    .then((res) => {
                        this.currentCustomer = res;
                        //console.debug('Customer: ', this.currentCustomer)
                        this.$store.dispatch('SET_CUSTOMER_JDE_NUMBER', res.JdeNum);
                        this.$store.dispatch('SET_CUSTOMER_IS_PRIVATE', res.IsPrivate);
                        if (!this.$route.params.id) {
                            this.updateBillingShippingInfo();
                            if(res.SalesTax !== null){
                                this.totals.salesTax = res.SalesTax;
                            }
                        }
                    })
                    .catch(err => {
                        // this.getCustomerByJde();
                        console.log(err)
                    })

            },
            getCurrentCustomerUnsavedOrder(id){
                if(!id) {
                    this.getCustomerByJde();
                    return;
                }
                CustomerService.get({id: id})
                    .then((res) => {
                        this.currentCustomer = res;
                        this.$store.dispatch('SET_CUSTOMER_JDE_NUMBER', res.JdeNum);
                        this.$store.dispatch('SET_CUSTOMER_IS_PRIVATE', res.IsPrivate);
                        this.updateBillingShippingInfo();

                        if(res.SalesTax !== null){
                            // this.OrderSalesSettings.SalesTax = res.SalesTax;
                            this.totals.salesTax = res.SalesTax
                        } else{
                            this.totals.salesTax = this.OrderSalesSettings.SalesTax;
                        }

                        if (this.totals.salesTax == 0) {
                            const country = this.shippingAddress.CountryId || 1
                            CountryService.states(Number(country))
                                .then(res => {
                                    this.shippingStatesUpdateKey++;
                                    this.shippingStates = res;
                                    this.computeSalesTaxRate()
                                    this.setTotals()
                                });
                        }

                        this.setTotals();
                    })
                    .catch(err => {
                        // this.getCustomerByJde();
                        console.log(err)
                    })

            },
            getCustomerByJde(){
                CustomerService.jde(this.customerJde)
                    .then(res => {
                            this.currentCustomer = res;
                            this.$store.dispatch('SET_CUSTOMER_JDE_NUMBER', this.customerJde);
                            this.$store.dispatch('SET_CUSTOMER_IS_PRIVATE', res.IsPrivate);
                            if (!this.$route.params.id) {
                                this.updateBillingShippingInfo();
                                if(res.SalesTax !== null){
                                    // this.OrderSalesSettings.SalesTax = res.SalesTax;
                                    this.totals.salesTax = res.SalesTax
                                }
                            }
                    })
                    .catch(err => {
                        console.log(err)
                    })
            },
            updateLegacyOrder(){
                this.orderLines.forEach(line => {
                    // line.OrderLineGroupId += maxBundleId;
                    // line.LineNumber += maxOrderLineNumber;
                    // line.InitialDealerCost = line.DealerCost;
                    // line = this.$refs.CustomerOrderGrid[0].createObjectForRow(line)
                    line = this.roundLine(line)
                })
                this.$refs.CustomerOrderGrid.forEach(grid => {
                    grid.summaryUpdateKey++;
                })
                this.setTotals();
                // this.OrderGridUpdateKey++;
            },
            getDefaultFreight(res){
                // console.log(res);
                let defaultFreight = null
                if(res.FreightPercentage === null){
                    defaultFreight = res.OrderSalesSettings.IsDefaultFreightPercent ? res.OrderSalesSettings.DefaultFreight : null;
                } else {
                    defaultFreight = res.FreightPercentage;
                }
                return defaultFreight;
            },
						getDealerType() {
							//return 'ZAHN';
							if (this.isHSUS) return 'HSUS';
							if (this.isHSCA) return 'HSCA';
							if (this.isZAHN) return 'ZAHN';

							console.error('Unknown dealer type. Defaulting to HSUS');
							return 'HSUS';
						},
            getDealerInfo(){
                let dealerId = this.currentUser.DealerId;

                DealerService.get(dealerId)
                    .then(res => {
												/*
                        console.log('Got Dealer: ', {
													dealer: res,
													StoreCode: res.StoreCode
												});
												*/

                        this.dealer = res;
                        this.isHSUS = this.dealer.StoreCode === 'HSUS'
												this.isHSCA = this.dealer.StoreCode === 'HSCA'
												this.isZAHN = this.dealer.StoreCode === 'ZAHN'
                        this.allowQuotePricing = this.dealer.AllowQuotePricing
												this.dealerType = this.getDealerType();

                        // Set default for Import Quote Pricing checkbox for HSUS
                        if (this.isHSUS) {
                            this.importQuotePricing = true;
                        }

												/*
												console.log('Dealer Values: ', {
													type: this.dealerType,
													isHSUS: this.isHSUS,
													isHSCA: this.isHSCA,
													isZAHN: this.isZAHN,
												});
												*/
                    })
                    .catch(err => {
                        console.log('err in getDealerInfo', err)
                    })
            },
            setupOrder(res, isDuplicate) {
                try {
                    //console.log('OrderService.get(): ', res);
                    this.customerJde = res.JdeNumber;

                    this.orderId = this.$route.params.id;
                    this.favoritesKey++;

                    this.orderNumber = res.OrderNumber

										this.$store.dispatch('UPDATE_ORDER_INFO', {number: res.OrderNumber, readOnly: res.IsOrderReadOnly || res.OrderStatusId !== 1});

										this.OrderSalesSettings = res.OrderSalesSettings;
                    this.getCurrentCustomer(res.CustomerId)
                    this.defaultGP = res.OrderSalesSettings.GPPercent;
                    // this.defaultFreightPercent = res.OrderSalesSettings.IsDefaultFreightPercent ? res.OrderSalesSettings.DefaultFreight : null;
                    this.defaultDownPaymentPercent = res.DownPaymentPercentage === null ? this.defaultDownPaymentPercent : res.DownPaymentPercentage;
                    this.defaultFreightPercent = res.FreightPercentage ? res.FreightPercentage : this.getDefaultFreight(res);
                    //console.log(this.defaultFreightPercent);
                    this.defaultFreightAmount = res.OrderSalesSettings.IsDefaultFreightPercent ? null : res.OrderSalesSettings.DefaultFreight;
                    // this.currentCustomer.Id = res.CustomerId;
                    this.orderStatusId = res.OrderStatusId;
                    this.worksheetName = res.WorksheetName;
                    // May need to confirm this.currentUser.DealerId == res.DealerId;
                    // this.?? = res.Status;

                    //console.debug("GOT HERE: ", res.RevisedOn)

                    this.creationDate = moment.utc(res.CreatedOn).local().format('L'),
                    this.creationTime = moment.utc(res.CreatedOn).local().format('LTS'),
                    this.revisionDate = moment.utc(res.RevisedOn).local().format('L');
                    this.revisionTime = moment.utc(res.RevisedOn).local().format('LTS');
                    this.committedDate = moment.utc(res.CommittedOn).local().format('L');
                    this.committedTime = moment.utc(res.CommittedOn).local().format('LTS');
                    this.submittedDate = moment.utc(res.SubmittedOn).local().format('L');
                    this.submittedTime = moment.utc(res.SubmittedOn).local().format('LTS');
                    this.installationDate = res.InstalledOn;
                    this.expirationDate = res.ExpiresOn;

                    this.paymentDueOn = res.PaymentDueOn;
                    this.billingAddress = res.BillingInfo;
                    this.shippingAddress = res.ShippingInfo;
                    this.installAddress = res.InstallationInfo ? res.InstallationInfo : {...res.ShippingInfo};
                    this.orderLines = this.sortOrderLinesByLineNumber(res.OrderLines);
                    this.bundles = res.Bundles;
                    this.resetBundleTotals();
                    this.generalNotes = res.GeneralNotes;
                    this.confidentialNotes = res.ConfidentialNotes;
                    this.totals.salesTax = res.SalesTaxRate;
                    this.totals.downPayment = res.DownPayment;
                    this.totals.subtotal = res.SubTotal;
                    this.totals.balanceDue = res.BalanceDue;
                    this.totals.discount = res.Discount;
                    this.totals.dealerCost = res.DealerCost;
                    this.totals.discountPercent = res.DiscountPercentage;
                    this.totals.profit = res.Profit;
                    this.totals.isFreightPercent = res.OrderSalesSettings.IsDefaultFreightPercent;
                    this.CustomDownPayment = res.CustomDownPayment;
                    this.CustomFreight = res.CustomFreight;
                    this.orderType = res.OrderTypeId;
                    if(res.Subtotal === 0){
                        this.totals.freight = 0;
                    } else if(res.CustomFreight){
                        this.totals.freight = res.Freight;
                    } else {
                        this.totals.freight = this.defaultFreightAmount;
                    }

                    //get default freight
                    if (res.FreightPercentage) {
                        //console.log(res.FreightPercentage);
                    };
                    if ((this.defaultFreightPercent || this.defaultFreightAmount) && isDuplicate) {
                        //console.log(this.defaultFreightPercent);
                        this.totals.freight = this.defaultFreightPercent ? this.roundToTwoDecimals((this.totals.subtotal * Number(this.defaultFreightPercent)/100)): this.defaultFreightAmount;
                    } else if((!this.defaultFreightPercent && !this.defaultFreightAmount) && isDuplicate) {
                        this.totals.freight = 0;
                    }

                    //calculate new taxable subtotal
                    const taxableTotal = this.OrderSalesSettings.TaxFreight ? this.totals.subtotal + this.totals.freight : this.totals.subtotal;

                    this.totals.salesTaxAmount = isDuplicate ? this.roundToTwoDecimals((taxableTotal * this.totals.salesTax)/100) : res.SalesTax;

                    this.totals.total = isDuplicate ? (this.totals.freight + this.totals.subtotal + this.totals.salesTaxAmount) : res.Total;

                    //get default down payment percent
                    if (this.defaultDownPaymentPercent && isDuplicate && res.DownPaymentPercentage === null) {
                        this.totals.downPayment = (this.totals.total * Number(this.defaultDownPaymentPercent)/100);
                    } else if (this.defaultDownPaymentPercent && isDuplicate && res.DownPaymentPercentage !== null) {
                        this.totals.downPayment = (this.totals.total * Number(res.DownPaymentPercentage)/100);
                    } else if (!this.defaultDownPaymentPercent && isDuplicate) {
                        this.totals.downPayment = 0;
                    };

                    this.ownerSalesRepId = res.SalesRepId;
                    this.EquipmentRepCode = res.EquipmentRepCode;
                    this.AdditionalRepCode = res.AdditionalRepCode;
                    this.AdditionalRep2Code = res.AdditionalRep2Code;
                    this.EquipmentRepName = res.EquipmentRepName;
                    this.AdditionalRepName = res.AdditionalRepName;
                    this.AdditionalRep2Name = res.AdditionalRep2Name;
                    this.transferredSalesRepId = res.TransferredFromRepId;
                    this.isReadOnly = res.IsOrderReadOnly;
										this.businessVersion = res.BusinessVersion;
                    this.rowVersion = res.RowVersion;

                    if(res.LegacyOrderNumber){
                        this.updateLegacyOrder();
                    }
                }
                catch(e) {
                    console.error('Got error setting up order: ', e)
                    this.$store.dispatch('ADD_NOTIFICATION', { text: 'Error setting up error: ' + e, type: 'error' });
                }
            },
            getCurrentOrder(isDuplicate, postProcess){
                if(this.$route.params.id){
                    // Check if this is a historical view request
                    const isHistorical = this.$route.query.historical === 'true' && this.$route.query.versionNumber

                    if (isHistorical) {
                        // Historical view mode - load order at specific version number
                        this.isHistoricalView = true
                        this.historicalAsOfTime = this.$route.query.asOfTime

                        OrderService.getAtVersion(this.$route.params.id, this.$route.query.versionNumber)
                            .then(res => {
                                this.setupOrder(res, isDuplicate)
                                // Force read-only for historical views
                                this.isReadOnly = true
                            })
                            .catch(err => {
                                console.error('Error loading historical order:', err)
                                this.$store.dispatch('ADD_NOTIFICATION', {
                                    text: 'Error loading historical order version',
                                    type: 'error'
                                })
                            })
                            .finally(() => {
                                this.afterOrderLoadTasks()
                            })
                    } else {
                        // Normal order load
                        OrderService.get({id: this.$route.params.id})
                            .then(res => {
                                this.setupOrder(res, isDuplicate);
                                if (postProcess) {
                                    postProcess();
                                    this.saveOrder();
                                }
                            })
                            .catch(err => {
                                console.error(err)
                            })
                            .finally(() => {
                                this.afterOrderLoadTasks()
                            })
                    }
                } else {
                    if(this.$route.params.cid){
                        this.getCurrentCustomerUnsavedOrder(this.$route.params.cid);
                    }else{
                        this.currentCustomer = this.defaultCustomer;
                    }
                    // this.orderId = null;
                    this.ownerSalesRepId = this.currentUser.SalesRepId;
                }
            },
            afterOrderLoadTasks() {
                // this.setTotals();
                let mimicEventDataBilling = {
                    target: {
                        value: this.billingAddress.CountryId || 1,
                        mimic: true
                    }
                }
                let mimicEventDataShipping = {
                    target: {
                        value: this.shippingAddress.CountryId || 1,
                        mimic: true
                    }
                }
                this.getStatesForCountryBilling(mimicEventDataBilling);
                this.getStatesForCountryShipping(mimicEventDataShipping);
                this.updateOrderLineNumbers();
                this.OrderGridUpdateKey++;
                this.resetRouteGuardCheck()
            },
            getSalesReps(){
                // let dealerId = this.currentUser.DealerId;
                DealerService.transferSalesReps().then(res => {
                    this.salesReps = res;
                    //console.log(this.salesReps);
                }).catch(err => {
                    this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message , type: 'error' });
                }).finally(() => {
                    this.resetRouteGuardCheck()
                })
            },
            getRegionFinanceRates() {
                DealerService.regionFinanceRates().then(res => {
                    this.regionFinanceRates = res;
                }).catch(err => {
                    this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message , type: 'error' });
                }).finally(() => {
                    this.resetRouteGuardCheck()
                })
            },
            getColleagues(){
							const showSpinner = false
                CoworkerService.all(showSpinner).then(res => {
                    this.colleagues = res.data;
                }).catch(err => {
                    this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message , type: 'error' });
                }).finally(() => {
                    this.resetRouteGuardCheck()
                })
            },

            getProducts(){
                ProductService.all().then(res => {
                    this.products = res;
                }).catch(err => {
                    this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message , type: 'error' });
                })
            },
            getReportTypes(){
							// obsolete
            },
            getOrderPrintOptions(){
                OrderPrintOptionsService.all()
                .then(res => {
                    this.printOptions = res
                    this.adecImportPrintOption = res[0].Id
                }) .catch(err => {
                    console.log(err)
                }).finally(() => {
                    this.resetRouteGuardCheck()
                })
                // this.adecImportPrintOption = this.printOptions[0].Id
            },
            // getOrders(){
            //     this.loading = true
            //     OrderService.all().then(response => {
            //         this.orders = response;
            //     }).catch(err => {
            //         console.log(err)
            //     }).finally(() => {
            //         this.loading = false
            //     })
            // },
           openOrder(){
                const isDuplicate = false;
                this.loading = true;
                this.totals = {...this.emptyTotal};
                this.orderLines = [];
                this.billingAddress = { ...this.emptyAddress };
                this.shippingAddress = { ...this.emptyAddress };
                this.installAddress = { ...this.emptyAddress };
                this.totalsSummary=[{...this.emptyTotal}];
                this.detailView = localStorage.getItem('detailView') === "true" ? true : false;
                // this.currentCustomer = this.defaultCustomer; // this will need to be changed when we import a customer from the customer search/order search page
                this.getCurrentOrder(isDuplicate)
                // this.updateBillingShippingInfo()
                this.getSalesReps()
                // this.getProducts();
                this.getDealerInfo();
                this.getOrderPrintOptions()
                this.getReportTypes();
                this.getOrderTypeOptions();
                this.getRegionFinanceRates();
                // await this.getOrders();
                this.formHasBeenChanged = false;
                this.avoidRouteGuard = true;
                this.loading = false;
                this.getColleagues()
            },
            resetRouteGuardCheck(){
                this.formHasBeenChanged = false;
                this.avoidRouteGuard = true;
            },
            sortOrderLinesByLineNumber(orderLines = this.orderLines){
                return orderLines.sort(function(a, b) {
                    var line1 = a.LineNumber;
                    var line2 = b.LineNumber;
                    return (line1 < line2) ? -1 : (line1 > line2) ? 1 : 0;
                });
            },
            saveWarning(){
                // alert('dont leave');
                if(!this.currentUser.OrderSaveAlertIntervalMins) return;
                let interval = this.currentUser.OrderSaveAlertIntervalMins * 60 * 1000;
                this.saveWarningInterval = setInterval(() => {
                    this.$store.dispatch('ADD_NOTIFICATION', { text: "Please save your work" , type: 'warning', timeout: interval, isSaveNotification: true });
                }, interval);
            },
            async warning(event) {
                event.preventDefault();
            },
            getCustomIcons(){
              let dealerId = this.currentUser.DealerId;
              if (!dealerId) return;
              DealerService.customIcons(dealerId).then(res => {
                  this.customIcons = res;
              }).catch(err => {
                  console.error(err);
              })
            },
            accessCoachPlus() {
                if (!this.currentCustomer || !this.currentCustomer.Id) {
                    this.$store.dispatch('ADD_NOTIFICATION', {text: 'Assign a customer and save worksheet to access Coach+', type: 'error'})
                    return
                }

                let data={
                    JdeNumber: this.currentCustomer.JdeNum,
                }
                UserService.hsusCoachPlus(data)
                    .then(res => {
                        window.open(res, '_blank');
                    })
                    .catch(err => {
                        console.log('error', err);
                        this.$store.dispatch('ADD_NOTIFICATION', {text: 'Unable to access CoachPlus at this time', type: 'error'})
                    })
                }
            },

        mounted() {
            this.getCustomIcons();
            this.isLimitedTransferUser = this.currentUser.IsLimitedTransferUser;
            this.isRestrictedSalesAdmin = this.currentUser.IsRestrictedSalesAdmin || false;
        },

        watch: {
            saveTrigger: function(){
                this.saveOrder();
            },
            '$route.params.id': function(newId, oldId) {
                if (newId && newId !== oldId) {
                    this.openOrder();
                }
            }
        },
        computed: {
            ...mapState(['currentUser', 'openRequestCount', 'saveTrigger']),
            orderVersioningEnabled() {
                return process.env.VUE_APP_ENABLE_ORDER_VERSIONING === 'true'
            },
            formatHistoricalTime() {
                if (!this.historicalAsOfTime) return ''
                const d = new Date(this.historicalAsOfTime)
                return d.toLocaleString('en-US', {
                    month: '2-digit',
                    day: '2-digit',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit'
                })
            },
            additionalRepOneOptions(){
                return this.colleagues.filter(colleague => {
                    return colleague.ShowInAdditionalRep1
                });
            },
            additionalRepTwoOptions(){
                const filtered = this.colleagues.filter(colleague => {
                    return colleague.ShowInAdditionalRep2
                });

                return filtered;
            },
            salesRepOptions(){
                return this.colleagues.filter(colleague => {
                    return colleague.ShowInSalesRep
                });
            },
            sequenceOptions(){
                let options = [];
                let newOptionId = 0;
                this.bundles.forEach((bundle, index) => {
                    if(index) options.push({text: bundle.OrderLineGroupId, value: bundle.OrderLineGroupId});
                    if(bundle.OrderLineGroupId >= newOptionId) newOptionId++;
                })
                options.push({text: newOptionId, value: newOptionId});
                return options;
            },
            printOptionsItems() {
                let options = []
                this.printOptions.forEach(option => {
                options.push({
                    text: option.DisplayName,
                    value: option.Id
                })
                })
                return options;
            },
            importedPrintOptionsItems(){
                return this.printOptionsItems.filter(option => {
                    return option.value !== 3;
                })
            },
            currentUserSalesAdminOrMgr(){
                let currentUserRole = getKeyByValue(userRoleEnum, this.currentUser.UserRoleId);
                return (['Sales Administrator', 'Sales Manager'].includes(currentUserRole));
            },
            currentUserSalesAdminOrAbove(){
                let currentUserRole = getKeyByValue(userRoleEnum, this.currentUser.UserRoleId);
                return (['SmartSales Admin', 'Sales Administrator'].includes(currentUserRole));
            },
            orderHasId(){
                return this.$route.params.id;
            },
            transferredRep(){
                let index = this.salesReps.map(rep => rep.SalesRepId).indexOf(this.transferredSalesRepId)
                if(index >= 0){
                   return this.salesReps[index].FirstName + " " + this.salesReps[index].LastName;
                } else {
                    return ""
                }
            },
            orderLinesSortedByLineNumber(){
                return this.sortOrderLinesByLineNumber()
            },
            committed(){
                return this.orderStatus === "Committed"
            },
            uncommitted(){
                return this.orderStatus === "Uncommitted"
            },
            submitted(){
                return this.orderStatus === "Submitted"
            },
            orderStatus(){
                //console.log('checking status');
                switch(this.orderStatusId) {
                    case 1:
                        return "Uncommitted"
                        break;
                    case 2:
                        return "Committed"
                        break;
                    case 3:
                        return "Submitted"
                        break;
                    default:
                        return "Lost in Space"
                    }
            },
        },
        beforeRouteLeave(to, from, next) {
            const answer = this.avoidRouteGuard || !this.formHasBeenChanged || to.name === 'Login' || this.committed || this.submitted || this.isReadOnly?
                true :
                window.confirm('Are you sure you would like to leave this page? You may have unsaved changes');
            if (answer) {
                clearInterval(this.saveWarningInterval);
                if(to.name !== 'CustomerOrderEdit'){
                    this.$store.dispatch('SET_CUSTOMER_JDE_NUMBER', null)
                    this.$store.dispatch('SET_CUSTOMER_IS_PRIVATE', false)
                }
                this.$store.dispatch('UPDATE_ORDER_INFO', {number: null, readOnly: false});
                next()
            } else {
                next(false)
            }
            this.avoidRouteGuard = false;

        },
        async created(){
            // document.addEventListener('beforeunload', this.beforePageDestroyed);
            // this.beforePageDestroyed();
            window.onbeforeunload = function(){
                return "Are you sure you want to close the window?";
            }
            window.addEventListener('beforeunload', this.warning);
            this.saveWarning();
            this.$route.params.id ?
            this.openOrder() :
            this.openNewOrder();
        },
        beforeDestroy() {
            window.removeEventListener('beforeunload', this.warning);
        },
    }
</script>

<!--
<style src="vue-slim-tabs/themes/default.css"></style>
-->

<style scoped lang="scss">
    .version-history-link {
        color: inherit;
        text-decoration: underline;
        font-weight: 600;
        cursor: pointer;
        &:hover {
            color: #0c5460;
            text-decoration: underline;
        }
    }
    .form-item{
        white-space: nowrap;
    }
    .customer-order-wrapper{
        // max-width: 1800px;
    }
    .customer-order-header{
        margin-bottom: 5px;
    }
    .header-order-id{
        color: $primary;
        font-size: 16px;
    }
    .modal-wrapper{
        min-width: 400px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        .card-header{
            min-width: 100%;
        }
        .btn-wrapper{
            margin-top: 25px;
            width: 100%;
            display: flex;
            justify-content: flex-end;
            align-items: flex-end;
            .btn{
                min-width: 125px;
            }
            &.center{
                justify-content: space-around;
                align-items: center;
            }
        }
    }
    .Uncommitted{
        color: $warning;
    }
    .Committed{
        color: $success;
    }
    .Submitted{
        color: $error;
    }
    .top-level-order-btns {
        width: 100%;
        font-size: .9em;
        .btn {
            font-size: .9em;
            //min-width: 110px;
            max-width: 125px;
            max-height: 30px;
            margin: 3px 0;
        }
    }
    .worksheet-input{
        font-size: 1.5em;
        color: $ss-grey;
        border: none;
        border-bottom: 1px solid $secondary;
        margin-left: 20px;
        //margin-bottom: 25px;
        //min-width: 500px;
    }

    @media only screen and (max-width: 500px) {
        .worksheet-input{
            min-width: unset;
        }
    }

    .lower-level-order-btns__right {
        display: flex;
        justify-content: space-around;
        margin-bottom: 50px;
        .btn {
            min-width: 135px;
            margin: 3px 0;
        }
    }

    .date-display {
        display: flex;
        flex-direction: column;
        //justify-content: space-around;
        //align-items: center;
        //height: 100%;
        margin: 3px;

        &__wrapper {
            display: flex;
            flex-direction: column;
            font-size: 10pt;
        }
        &__title {
            font-weight: bolder;
        }
        &__value {
            font-style: italic;
        }
    }
    .customer-info-header-wrapper{
        display: flex;
        justify-content: space-between;
        .show-details-toggle{
            cursor: pointer;
            margin-bottom: 0px;
        }
    }
    .grid-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .lower-section {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        grid-template-rows: 1fr 1fr;
        grid-column-gap: 25px;
        grid-row-gap: 25px;
        .hide-confidential{
            grid-column-start: 1;
            grid-column-end: 3  ;
            grid-row-start: 2;
            grid-row-end: 2
        }
        .summary {
            grid-column-start: 3;
            grid-column-end: 3;
            grid-row-start: 1;
            grid-row-end: 3
        }
    }
    .dropdown-menu {
        padding: 10px;
        background-color: $black-050;
        border: solid 1px $secondary;
        border-radius: 4px;
        box-shadow: $box-shadow;
    }
    .dropdown-toggle {
        margin: -20px;
    }


    /* The switch - the box around the slider */
    .switch {
        transform: scale(0.75);
        position: relative;
        display: inline-block;
        width: 60px;
        height: 34px;
    }

    /* Hide default HTML checkbox */
    .switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    /* The slider */
    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: $ss-grey2;
        -webkit-transition: .4s;
        transition: .4s;
    }

    .slider:before {
        position: absolute;
        content: "";
        height: 26px;
        width: 26px;
        left: 4px;
        bottom: 4px;
        background-color: white;
        -webkit-transition: .4s;
        transition: .4s;
    }

    input:checked + .slider {
        background-color: $primary;
    }

    input:focus + .slider {
        box-shadow: 0 0 1px $primary;
    }

    input:checked + .slider:before {
        -webkit-transform: translateX(26px);
        -ms-transform: translateX(26px);
        transform: translateX(26px);
    }
    .order-link-btn{
        color: $error;
    }
    /* Rounded sliders */
    .slider.round {
        border-radius: 34px;
    }

    .slider.round:before {
        border-radius: 50%;
    }
    .modal-text{
        text-align: center;
        margin-top: 10px;
        margin-bottom: 0px;
    }

    .date-area {
        margin-top: 15px;
        table tr td {
            padding-right: 10px;
        }
    }

    .custom-area {
        margin-top: 15px;
        margin-bottom: 5px;
        table tr td {
            padding-right: 10px;
        }
    }

		.first-line {
			text-align: right;
		}

		.second-line {
			text-align: right;
			margin-left: 25px;
		}

		@media only screen and (max-width: 1200px) {
        .second-line {
					width: 100%;
        }
    }

		@media only screen and (max-width: 1000px) {
        .second-line {
					text-align: left;
        }
    }

</style>

<style>
    .vue-tablist {
        list-style: none;
        display: flex;
        padding-left: 0;
        border-bottom: 1px solid #e2e2e2;
        margin-bottom: 0;
    }

    .vue-tab {
        padding: 5px 10px;
        cursor: pointer;
        user-select: none;
        border: 1px solid transparent;
        border-bottom-color: #e2e2e2;
        border-radius: 3px 3px 0 0;
        background-color: white;
        position: relative;
        bottom: -1px;
    }

    .vue-tab[aria-selected="true"] {
        border-color: #e2e2e2;
        border-bottom-color: transparent;
        background-color: rgb(233, 236, 239);
        font-weight: bold;
    }

    .vue-tab[aria-disabled="true"] {
        cursor: not-allowed;
        color: #999;
    }
</style>
